// Chemin: C:\gestion-copro\src\pages\vigie\SentinelleVigiePage.tsx
// Page SENTINELLE VIGIE — Chat plein écran (sas d'entrée unique)
// Session 100 : Placeholder
// Session 102 : Hub statique
// Session 103 : REFONTE COCKPIT — Analyse document + Génération courrier
// Session 106 : Fix archivage — utilise categorie directe SENTINELLE (taxonomie GED v2)
// Session 107 : Fix câblage cockpit→courrier (navigate avec state)
// Session 108 : Intégration onboarding conversationnel — Si onboarding non terminé → affiche OnboardingSentinelleVigie
// Session 110 : Chantier 1 — Bandeau checklist documentaire + widget complétude + relances + interlocuteurs
// Session 111 : Détection doublons SHA-256 avant archivage + stockage fileHash
// Session 113 : Limite upload affichée portée à 25 Mo (alignement documentAnalysis.service)
// Session 117 : REFONTE — Zone courrier remplacée par chat SENTINELLE inline (sas d'entrée unique).
// Session 118 : REFONTE PLEIN ÉCRAN — Chat SENTINELLE occupe toute la page.
//               Dropzone intégrée dans la zone de saisie (trombone + drag'n'drop).
//               Checklist, quotas, historique migrent vers DashboardVigiePage.
//               Bandeau alerte quota si < 5 analyses restantes.
// Session 120 : Persistance donneesCles dans Firestore (2 niveaux : premier niveau + analyseSentinelle)
// Session 121 : Reset complet "Nouveau chat" (clean slate) + détection intelligente destinataireType (promoteur/syndic/assurance)
// Session 122 : Fix nom destinataire — extraction robuste pour ne plus passer l'ID Firestore au formulaire courrier
// Session 126 : Activation create_affaire + fix create_signalement + injection contexte dossier via URL params
// Session 128 : Injection contexte signalement — SENTINELLE reçoit titre, description, catégorie, urgence, localisation depuis SignalementDetailVigiePage
// Session 130 : Ajout suggestion "Mes prochaines échéances" + carte capacité Calendrier
// Session 135 : CENTRALISATION — archivage document via uploadDocument() (porte unique GED)
//               Suppression addDoc direct dans 'documents' → remplacé par document.service.uploadDocument()
// Session 141 : PERSISTANCE CHAT — Messages sauvegardés dans Firestore via conversation.service.ts
// Session 160 : Transmission destinatairesCC (suggestion CC) dans le prefill courrier
// Session 161 : Affichage spécifique document hors périmètre — pas de bouton Archiver, message explicite
//               Suppression ChatMessageLocal → utilisation ChatMessage (chat.types.ts)
//               Chargement conversation active au montage, sauvegarde auto après chaque échange
//               Suppression conversation Firestore sur "Nouveau chat"
// Session 144 : INTELLIGENCE CORRESPONDANCE — Affichage alerte qualité dans carte analyse
//               Passage champs correspondance à uploadDocument() (2 chemins : normal + doublon)
//               Import Link lucide pour lien courrier lié
// Session 153 : SUGGESTIONS DYNAMIQUES — Remplacement boutons statiques par suggestions contextuelles
//               du contextBuilder via fetchSuggestions() (zéro Claude, zéro quota)
// Session 154 : Ajout handler create_interlocuteur — création contact depuis chat SENTINELLE
//               (extraction membres CS depuis PV d'AG)
// Session 167 : Message post-archivage orienté valeur utilisateur (Principe 10)
//               Quand un règlement de copropriété est archivé avec tantièmes extraits,
//               SENTINELLE guide vers l'étape suivante (uploade ton relevé de charges)
//               Réécriture message confirmation update_profil_tantiemes (Principe 10)
// Session 168 : Post-archivage intelligent — détection croisée GED
//               Si règlement archivé + appel de charges existant → propose calcul immédiat
//               Si appel de charges archivé + règlement existant → propose calcul immédiat
//               Bouton suggestion "Calcule mes charges récupérables" déclenche le calcul automatiquement
//               Même logique appliquée au chemin archivage doublon
// Session 169 : Fix types de charges — ajout 'releve' et 'appel_fonds' dans typesCharges
//               (types réels en base Firestore, manquaient dans la détection post-archivage)
// Session 172 : Refonte écran d'accueil — suppression cartes capacités verbeuses,
//               suggestions remontées sous le hero, design épuré avec icônes et headers colonnes,
//               boutons rounded-xl au lieu de rounded-full, meilleure hiérarchie visuelle
// Session 180 : Injection contexte relance depuis CalendrierVigiePage (?contexte=relance&courrierId=XXX)
//               SENTINELLE reçoit le titre du courrier et propose une relance SCUD graduée
// Session 181 : Export PDF résultats structurés SENTINELLE — bouton conditionnel "Exporter en PDF"
//               Affiché uniquement quand le message contient des tableaux ou marqueurs P10
// Session 182 : Nettoyage markdown dans contenu courrier (strip **gras**, *italique*, ### titres)
//               Détection intelligente du type de courrier (notification, relance, réclamation...)
//               au lieu du fallback systématique 'demande_information'
// Session 186 : FIX DOUBLONS — uploadDocument() vérifie désormais les doublons en interne.
//               confirmerArchivageMalgreDoublon passe skipDuplicateCheck: true.
//               Tous les autres chemins (archiverDocument, archivage inline+relance) sont protégés.
//               Traitement erreur DOUBLON_DETECTE dans les catch pour message utilisateur propre.
// Session 195 : Bouton "Archiver dans mes documents" redirige vers AjouterDocumentVigiePage
//               via navigate avec resultatAnalyse en state — tunnel unique GED avec validation utilisateur.
//               Le chemin "Archiver et rédiger une relance" (IC) conserve l'archivage direct (flux relance).
// Session 215 : Double sécurité courrier — handleAction accepte sourceCourrier (CourrierGenere)
// Session 227 : Niveau 2 Intelligence Comptable — action verifier_comptabilite depuis chat SENTINELLE
//               prioritaire sur action.data.contenu pour éviter la troncature.
//               Fix bug doublon : ordre setErreurAnalyse corrigé (visible même quand fileOriginal absent).
// Session 228 : Niveau 3 Intelligence Comptable — détection proactive à l'archivage d'un doc comptable
// Session 235 : create_signalement redirige vers /vigie/dossiers/nouveau (signalement supprimé VIGIE)
// Session 261 : Handler archive_document — liste les documents sans affaireId + invite à préciser le dossier cible
//               Si vérification en cours pour l'exercice → propose d'y accéder directement
//               Si aucune vérification → propose d'en créer une via action verifier_comptabilite
//               Action update_profil_bailleur — activation mode bailleur sans console Firestore

import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useCopropriete } from '../../context/CoproprieteContext';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { doc, getDoc, updateDoc, collection, query, where, Timestamp, serverTimestamp, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';
import {
  Send,
  Shield,
  AlertTriangle,
  CheckCircle,
  Loader2,
  X,
  Archive,
  FileText,
  Upload,
  Paperclip,
  RotateCcw,
  Copy,
  Sparkles,
  FolderOpen,
  Calendar,
  CreditCard,
  Home,
  Download
} from 'lucide-react';

// Services existants
import { verifierFichier } from '../../services/gardien.service';
import {
  isFileAccepted,
  uploadTempFile,
  deleteTempFile,
  analyzeDocument,
  computeFileHash,
  type DocumentSuggestion
} from '../../services/documentAnalysis.service';

// Chat SENTINELLE
import { askAssistant, fetchSuggestions, AssistantResult, SuggestionsResult } from '../../services/assistant.service';
import { ChatMessage, ProposedAction, CourrierGenere } from '../../types/chat.types';
import SentinelleAvatar from '../../components/chat/SentinelleAvatar';
import { renderMarkdown } from '../../components/chat/ChatMessage';
import BoutonDictee from '../../components/chat/BoutonDictee';

// Session 141 : Persistance conversation Firestore
import {
  getActiveConversation,
  createConversation,
  updateConversationMessages,
  deleteConversation,
  convertFirestoreMessages
} from '../../services/conversation.service';

// Vérification doublons + archivage centralisé
import { checkDuplicateByHash, uploadDocument, type DuplicateCheckResult } from '../../services/document.service';

// Onboarding conversationnel
import OnboardingSentinelleVigie from '../../components/vigie/OnboardingSentinelleVigie';
import { getOnboardingState, resetOnboarding } from '../../services/onboarding.service';
import { OnboardingStepId, OnboardingData } from '../../types/onboarding.types';

// Session 146 : Création événement calendrier depuis chat SENTINELLE
import { creerEcheance } from '../../services/echeance.service';
// Session 218 : Création paiement bailleur depuis quittance GED
import { createPaiement } from '../../services/suiviBailleur.service';
// Session 227 : Création vérification comptable depuis chat SENTINELLE
import { createVerification } from '../../services/verification.service';
// Session 181 : Export PDF résultats structurés SENTINELLE
import { isResultatStructure, telechargerPDFSentinelle } from '../../services/pdfSentinelle.service';
// Session 248 : Mise à jour dossier depuis chat SENTINELLE (Bug 2)
import { updateAffaire, addEvenementToAffaire, rattacherDocument, rattacherCourrier } from '../../services/affaire.service';
import { UpdateAffaireData } from '../../types/affaire.types';

// ============================================================================
// TYPES LOCAUX
// ============================================================================

interface ResultatAnalyse {
  suggestion: DocumentSuggestion;
  fileName: string;
  fileUrl: string;
  filePath: string;
  fileType: string;
  fileSize: number;
  fileHash: string;
  fileOriginal?: File;
}

interface QuotaVigie {
  analysesUtilisees: number;
  analysesMax: number;
}

// ============================================================================
// COMPOSANT PRINCIPAL
// ============================================================================

const SentinelleVigiePage: React.FC = () => {
  const { firebaseUser, userProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { coproprieteId, refreshCopropriete } = useCopropriete();
  const prenom = userProfile?.prenom || 'vous';

  // --- Contexte dossier (injection depuis AffaireDetailVigiePage) ---
  const [searchParams, setSearchParams] = useSearchParams();
  const [contexteDossier, setContexteDossier] = useState<{
    id: string;
    titre: string;
    type?: string;
    description?: string;
    nbDocs?: number;
  } | null>(null);
  const [contexteInjecte, setContexteInjecte] = useState(false);

  // --- Contexte signalement (injection depuis SignalementDetailVigiePage) — Session 128 ---
  const [contexteSignalement, setContexteSignalement] = useState<{
    id: string;
    titre: string;
    description?: string;
    categorie?: string;
    urgence?: string;
    localisation?: string;
    localisationDetail?: string;
    statut?: string;
  } | null>(null);
  const [contexteSignalementInjecte, setContexteSignalementInjecte] = useState(false);
  // Session 128 : ID du dossier parent du signalement (pour rattachement auto courrier)
  const [affaireIdPourSignalement, setAffaireIdPourSignalement] = useState<string | null>(null);

  // --- Contexte relance (injection depuis CalendrierVigiePage) — Session 180 ---
  const [contexteRelance, setContexteRelance] = useState<{
    courrierId: string;
    titre: string;
  } | null>(null);
  const [contexteRelanceInjecte, setContexteRelanceInjecte] = useState(false);

  // Session 232 : Contexte règlement appel de fonds depuis VerificationDetailVigiePage
  const [contexteReglement, setContexteReglement] = useState<{
    trimestre: string;
    montant: string;
    exercice: string;
    documentNom: string;
  } | null>(null);
  const [contexteReglementInjecte, setContexteReglementInjecte] = useState(false);
  // Session 246 : Message pré-rempli depuis AjouterDocumentVigiePage (tantièmes)
  const [messagePreRempliInjecte, setMessagePreRempliInjecte] = useState(false);

  // --- Onboarding ---
  const [onboardingLoading, setOnboardingLoading] = useState(true);
  const [onboardingComplete, setOnboardingComplete] = useState<boolean | null>(null);
  const [onboardingInitialStep, setOnboardingInitialStep] = useState<OnboardingStepId>('accueil');
  const [onboardingInitialData, setOnboardingInitialData] = useState<Partial<OnboardingData>>({});

  // --- Chat SENTINELLE ---
  // Session 141 : ChatMessageLocal supprimé → ChatMessage (chat.types.ts)
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
  const [chatInput, setChatInput] = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const [chatError, setChatError] = useState<string | null>(null);
  const chatEndRef = useRef<HTMLDivElement>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);

  // Session 141 : Persistance conversation
  const [conversationId, setConversationId] = useState<string | null>(null);
  const [conversationLoaded, setConversationLoaded] = useState(false);
  const savingRef = useRef(false);

  // --- Analyse document (intégrée dans le chat) ---
  const [isDragOver, setIsDragOver] = useState(false);
  const [analyseEnCours, setAnalyseEnCours] = useState(false);
  const [etapeAnalyse, setEtapeAnalyse] = useState('');
  const [resultatAnalyse, setResultatAnalyse] = useState<ResultatAnalyse | null>(null);
  const [erreurAnalyse, setErreurAnalyse] = useState<string | null>(null);
  const [archivageEnCours, setArchivageEnCours] = useState(false);
  const [doublonDetecte, setDoublonDetecte] = useState<DuplicateCheckResult | null>(null);

  // --- Quota (uniquement pour l'alerte inline) ---
  const [quota, setQuota] = useState<QuotaVigie | null>(null);

  // --- Session 153 : Suggestions dynamiques accueil ---
  const [suggestionsAccueil, setSuggestionsAccueil] = useState<string[]>([]);
  const [suggestionsBailleur, setSuggestionsBailleur] = useState<string[]>([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);

  // ============================================================================
  // PERSISTANCE — Session 141
  // ============================================================================

  /**
   * Sauvegarde les messages dans Firestore (création ou mise à jour)
   * Protégé par savingRef pour éviter les appels concurrents
   */
  const sauvegarderConversation = useCallback(async (messages: ChatMessage[], currentConversationId: string | null) => {
    if (!coproprieteId || !firebaseUser || savingRef.current) return;
    if (messages.length === 0) return;

    savingRef.current = true;
    try {
      if (currentConversationId) {
        // Mise à jour conversation existante
        await updateConversationMessages(coproprieteId, currentConversationId, messages);
      } else {
        // Création nouvelle conversation
        const newId = await createConversation(coproprieteId, firebaseUser.uid, messages);
        setConversationId(newId);
      }
    } catch (error) {
      console.error('[SENTINELLE] Erreur sauvegarde conversation:', error);
    } finally {
      savingRef.current = false;
    }
  }, [coproprieteId, firebaseUser]);

  // ============================================================================
  // EFFETS
  // ============================================================================

  // Vérifier l'état de l'onboarding au chargement
  useEffect(() => {
    if (!coproprieteId) {
      setOnboardingLoading(false);
      return;
    }

    const checkOnboarding = async () => {
      try {
        const state = await getOnboardingState(coproprieteId);
        setOnboardingComplete(state.onboardingComplete);
        if (!state.onboardingComplete) {
          setOnboardingInitialStep(state.onboardingStep);
          setOnboardingInitialData(state.onboardingData);
        }
      } catch (error) {
        console.error('[SentinelleVigie] Erreur vérification onboarding:', error);
        setOnboardingComplete(true);
      } finally {
        setOnboardingLoading(false);
      }
    };

    checkOnboarding();
  }, [coproprieteId]);

  // Session 141 : Charger la conversation active au montage
  useEffect(() => {
    if (!coproprieteId || !firebaseUser || onboardingComplete !== true || conversationLoaded) return;

    // Ne pas charger si on arrive avec un contexte dossier/signalement (nouvelle conversation forcée)
    const contexte = searchParams.get('contexte');
    if (contexte) {
      setConversationLoaded(true);
      return;
    }

    const chargerConversation = async () => {
      try {
        const conv = await getActiveConversation(coproprieteId, firebaseUser.uid);
        if (conv && conv.messages && conv.messages.length > 0) {
          const messages = convertFirestoreMessages(conv.messages);
          setChatMessages(messages);
          setConversationId(conv.id);
        }
      } catch (error) {
        console.error('[SENTINELLE] Erreur chargement conversation:', error);
      } finally {
        setConversationLoaded(true);
      }
    };

    chargerConversation();
  }, [coproprieteId, firebaseUser, onboardingComplete, conversationLoaded, searchParams]);

  // Session 153 : Charger les suggestions dynamiques à l'ouverture
  // Appel léger (Firestore uniquement, zéro Claude, zéro quota)
  useEffect(() => {
    if (!coproprieteId || onboardingComplete !== true) return;

    const chargerSuggestions = async () => {
      setSuggestionsLoading(true);
      try {
        const result = await fetchSuggestions(coproprieteId);
        // Session 170 : Support suggestions catégorisées (générales + bailleur)
        if (Array.isArray(result)) {
          // Ancien format : tableau simple (compatibilité)
          if (result.length > 0) {
            setSuggestionsAccueil(result);
          }
        } else if (result && typeof result === 'object') {
          // Nouveau format : { suggestions, suggestionsBailleur, isBailleur }
          if (result.suggestions && result.suggestions.length > 0) {
            setSuggestionsAccueil(result.suggestions);
          }
          if (result.suggestionsBailleur && result.suggestionsBailleur.length > 0) {
            setSuggestionsBailleur(result.suggestionsBailleur);
          }
        }
      } catch (error) {
        console.error('[SENTINELLE] Erreur chargement suggestions:', error);
      } finally {
        setSuggestionsLoading(false);
      }
    };

    chargerSuggestions();
  }, [coproprieteId, onboardingComplete]);

  // Lire les paramètres URL pour injection de contexte (dossier ou signalement)
  useEffect(() => {
    const contexte = searchParams.get('contexte');
    if (contexte === 'dossier') {
      const id = searchParams.get('id');
      const titre = searchParams.get('titre');
      if (id && titre) {
        setContexteDossier({
          id,
          titre: decodeURIComponent(titre),
          type: searchParams.get('type') || undefined,
          description: searchParams.get('description') ? decodeURIComponent(searchParams.get('description')!) : undefined,
          nbDocs: searchParams.get('nbDocs') ? parseInt(searchParams.get('nbDocs')!, 10) : undefined,
        });
      }
      // Nettoyer les params URL sans recharger la page
      setSearchParams({}, { replace: true });
    } else if (contexte === 'signalement') {
      // Session 128 : Injection contexte signalement
      const id = searchParams.get('id');
      const titre = searchParams.get('titre');
      if (id && titre) {
        setContexteSignalement({
          id,
          titre: decodeURIComponent(titre),
          description: searchParams.get('description') ? decodeURIComponent(searchParams.get('description')!) : undefined,
          categorie: searchParams.get('categorie') ? decodeURIComponent(searchParams.get('categorie')!) : undefined,
          urgence: searchParams.get('urgence') || undefined,
          localisation: searchParams.get('localisation') ? decodeURIComponent(searchParams.get('localisation')!) : undefined,
          localisationDetail: searchParams.get('localisationDetail') ? decodeURIComponent(searchParams.get('localisationDetail')!) : undefined,
          statut: searchParams.get('statut') ? decodeURIComponent(searchParams.get('statut')!) : undefined,
        });

        // Session 128 : Chercher le dossier parent de ce signalement (pour rattachement auto courrier)
        if (coproprieteId) {
          const affairesQuery = query(
            collection(db, 'affaires'),
            where('coproprieteId', '==', coproprieteId),
            where('signalementIds', 'array-contains', id)
          );
          getDocs(affairesQuery).then(snapshot => {
            if (!snapshot.empty) {
              setAffaireIdPourSignalement(snapshot.docs[0].id);
            }
          }).catch(() => { /* non bloquant */ });
        }
      }
      // Nettoyer les params URL sans recharger la page
      setSearchParams({}, { replace: true });
    } else if (contexte === 'relance') {
      // Session 180 : Injection contexte relance depuis CalendrierVigiePage
      const courrierId = searchParams.get('courrierId');
      const titre = searchParams.get('titre');
      if (courrierId && titre) {
        setContexteRelance({
          courrierId,
          titre: decodeURIComponent(titre),
        });
      }
      // Nettoyer les params URL sans recharger la page
      setSearchParams({}, { replace: true });
    } else if (contexte === 'reglement') {
      // Session 232 : Injection contexte règlement appel de fonds depuis VerificationDetailVigiePage
      const trimestre = searchParams.get('trimestre');
      const montant = searchParams.get('montant');
      const exercice = searchParams.get('exercice');
      const documentNom = searchParams.get('documentNom');
      if (trimestre && montant) {
        setContexteReglement({
          trimestre: decodeURIComponent(trimestre),
          montant: decodeURIComponent(montant),
          exercice: exercice ? decodeURIComponent(exercice) : '',
          documentNom: documentNom ? decodeURIComponent(documentNom) : '',
        });
      }
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  // Injection automatique du contexte dossier comme premier message
  useEffect(() => {
    if (!contexteDossier || contexteInjecte || onboardingComplete !== true) return;

    const nbDocsLabel = contexteDossier.nbDocs !== undefined && contexteDossier.nbDocs > 0
      ? ` (${contexteDossier.nbDocs} document${contexteDossier.nbDocs > 1 ? 's' : ''} analysé${contexteDossier.nbDocs > 1 ? 's' : ''} disponible${contexteDossier.nbDocs > 1 ? 's' : ''})`
      : '';
    const messageContexte = contexteDossier.description
      ? `Je travaille sur mon dossier "${contexteDossier.titre}"${nbDocsLabel}. Voici le contexte : ${contexteDossier.description}. Que me conseilles-tu ?`
      : `Je travaille sur mon dossier "${contexteDossier.titre}"${nbDocsLabel}. Que me conseilles-tu ?`;

    // Envoyer automatiquement le message de contexte
    setContexteInjecte(true);
    envoyerMessageChat(messageContexte);
  }, [contexteDossier, contexteInjecte, onboardingComplete]);

  // Session 128 : Injection automatique du contexte signalement comme premier message
  useEffect(() => {
    if (!contexteSignalement || contexteSignalementInjecte || onboardingComplete !== true) return;

    // Construire un message riche avec toutes les infos du signalement
    const parties: string[] = [];
    parties.push(`J'ai un signalement : "${contexteSignalement.titre}".`);
    if (contexteSignalement.description) {
      parties.push(`Description : ${contexteSignalement.description}`);
    }
    if (contexteSignalement.categorie) {
      parties.push(`Catégorie : ${contexteSignalement.categorie}.`);
    }
    if (contexteSignalement.urgence) {
      parties.push(`Urgence : ${contexteSignalement.urgence}.`);
    }
    if (contexteSignalement.localisation) {
      const locDetail = contexteSignalement.localisationDetail
        ? ` (${contexteSignalement.localisationDetail})`
        : '';
      parties.push(`Localisation : ${contexteSignalement.localisation}${locDetail}.`);
    }
    if (contexteSignalement.statut) {
      parties.push(`Statut actuel : ${contexteSignalement.statut}.`);
    }
    parties.push('Aide-moi à rédiger un courrier adapté à cette situation.');

    setContexteSignalementInjecte(true);
    envoyerMessageChat(parties.join(' '));
  }, [contexteSignalement, contexteSignalementInjecte, onboardingComplete]);

  // Session 180 : Injection automatique du contexte relance comme premier message
  useEffect(() => {
    if (!contexteRelance || contexteRelanceInjecte || onboardingComplete !== true) return;

    const messageRelance = `Mon courrier "${contexteRelance.titre}" est arrivé à échéance sans réponse. Prépare-moi une relance adaptée.`;

    setContexteRelanceInjecte(true);
    envoyerMessageChat(messageRelance);
  }, [contexteRelance, contexteRelanceInjecte, onboardingComplete]);

  // Session 232 : Injection automatique du contexte règlement appel de fonds
  useEffect(() => {
    if (!contexteReglement || contexteReglementInjecte || onboardingComplete !== true) return;

    const parties: string[] = [];
    parties.push(`Je souhaite régler mon appel de fonds ${contexteReglement.trimestre}${contexteReglement.exercice ? ` (exercice ${contexteReglement.exercice})` : ''} d'un montant de ${contexteReglement.montant} €.`);
    if (contexteReglement.documentNom) {
      parties.push(`Référence document : ${contexteReglement.documentNom}.`);
    }
    parties.push(`Rédige-moi un courrier d'accompagnement de règlement à adresser au syndic, en précisant le montant, la période concernée et en indiquant que le virement a été effectué.`);

    setContexteReglementInjecte(true);
    envoyerMessageChat(parties.join(' '));
  }, [contexteReglement, contexteReglementInjecte, onboardingComplete]);

  // Session 246 : Injection message pré-rempli depuis location.state
  useEffect(() => {
    const messagePreRempli = location.state?.messagePreRempli;
    if (!messagePreRempli || messagePreRempliInjecte || onboardingComplete !== true) return;
    setMessagePreRempliInjecte(true);
    envoyerMessageChat(messagePreRempli);
  }, [location.state, messagePreRempliInjecte, onboardingComplete]);

  // Charger quotas pour l'alerte inline
  useEffect(() => {
    if (!coproprieteId || onboardingComplete !== true) return;
    chargerQuotas();
  }, [coproprieteId, onboardingComplete]);

  const chargerQuotas = async () => {
    if (!coproprieteId) return;
    try {
      const quotaDoc = await getDoc(doc(db, 'quotas', coproprieteId));
      if (quotaDoc.exists()) {
        const data = quotaDoc.data();
        // Fix session 242 : sentinelleUsage est un objet {analysesEffectuees, quota, dateDebut}
        const usageRaw = data.sentinelleUsage;
        const usage = (typeof usageRaw === 'object' && usageRaw !== null)
          ? (usageRaw.analysesEffectuees ?? 0)
          : (typeof usageRaw === 'number' ? usageRaw : 0);
        setQuota({
          analysesUtilisees: usage,
          analysesMax: data.analysesMax || data.sentinelleQuota || 100,
        });
        return;
      }
      // Fallback : coproprietes
      const coproDoc = await getDoc(doc(db, 'coproprietes', coproprieteId));
      if (coproDoc.exists()) {
        const data = coproDoc.data();
        // Fix session 242 : sentinelleUsage est un objet {analysesEffectuees, quota, dateDebut}
        const usageRaw = data.sentinelleUsage;
        const usage = (typeof usageRaw === 'object' && usageRaw !== null)
          ? (usageRaw.analysesEffectuees ?? 0)
          : (typeof usageRaw === 'number' ? usageRaw : 0);
        const quotaVal = (typeof usageRaw === 'object' && usageRaw !== null)
          ? (usageRaw.quota ?? data.sentinelleQuota ?? 100)
          : (data.sentinelleQuota ?? 100);
        setQuota({
          analysesUtilisees: usage,
          analysesMax: quotaVal,
        });
      }
    } catch (error) {
      console.error('Erreur chargement quotas:', error);
    }
  };

  // Auto-scroll vers le dernier message
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatMessages, chatLoading, resultatAnalyse, analyseEnCours]);

  // ============================================================================
  // ANALYSE DOCUMENT (intégrée dans le flux chat)
  // ============================================================================

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);
  }, []);

  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      lancerAnalyse(files[0]);
    }
  }, [coproprieteId]);

  const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      lancerAnalyse(files[0]);
    }
    e.target.value = '';
  }, [coproprieteId]);

  const lancerAnalyse = async (file: File) => {
    if (!coproprieteId || !firebaseUser) return;

    // Reset états
    setResultatAnalyse(null);
    setErreurAnalyse(null);
    setDoublonDetecte(null);
    setAnalyseEnCours(true);

    try {
      // Étape 1 : Vérification locale
      setEtapeAnalyse('Vérification du fichier...');
      const verificationGardien = verifierFichier(file);
      if (!verificationGardien.accepte) {
        setErreurAnalyse(verificationGardien.erreur || 'Fichier non accepté');
        setAnalyseEnCours(false);
        return;
      }

      const verificationAnalyse = isFileAccepted(file);
      if (!verificationAnalyse.accepted) {
        setErreurAnalyse(verificationAnalyse.reason || 'Fichier non supporté pour l\'analyse');
        setAnalyseEnCours(false);
        return;
      }

      // Étape 1b : Hash SHA-256
      setEtapeAnalyse('Empreinte du fichier...');
      const fileHash = await computeFileHash(file);

      // Étape 1c : Vérification doublon
      setEtapeAnalyse('Vérification des doublons...');
      const doublonCheck = await checkDuplicateByHash(coproprieteId, fileHash, file.name, file.size);
      if (doublonCheck.isDuplicate) {
        setDoublonDetecte(doublonCheck);
        setResultatAnalyse({
          suggestion: {
            typeDocument: '',
            typeDocumentLabel: '',
            categorie: '',
            categorieLabel: '',
            titre: doublonCheck.existingDocumentTitre || file.name,
            description: '',
            dateDocument: null,
            interlocuteurId: null,
            interlocuteurNom: null,
            affaireId: null,
            affaireNom: null,
            confidence: 'haute',
            explication: '',
            anomalies: [],
            actionsRecommandees: [],
            donneesCles: {}
          },
          fileName: file.name,
          fileUrl: '',
          filePath: '',
          fileType: file.type,
          fileSize: file.size,
          fileHash,
          fileOriginal: file
        });
        setAnalyseEnCours(false);
        setEtapeAnalyse('');
        return;
      }

      // Étape 2 : Upload temporaire
      setEtapeAnalyse('Envoi du document à SENTINELLE...');
      const { url, path } = await uploadTempFile(file, coproprieteId, firebaseUser.uid);

      // Étape 3 : Analyse IA
      setEtapeAnalyse('SENTINELLE analyse le document...');
      const resultat = await analyzeDocument(url, file.name, file.type, coproprieteId);

      if (resultat.success && resultat.suggestion) {
        setResultatAnalyse({
          suggestion: resultat.suggestion,
          fileName: file.name,
          fileUrl: url,
          filePath: path,
          fileType: file.type,
          fileSize: file.size,
          fileHash
        });
      } else {
        // Session 215 : message enrichi pour diagnostic — inclut le retour exact de la fonction
        const detailErreur = resultat.error
          ? resultat.error
          : !resultat.success
            ? `La fonction a retourné success=false sans message d'erreur.`
            : `La fonction a retourné success=true mais suggestion est vide (${JSON.stringify(resultat.suggestion)}).`;
        setErreurAnalyse(`Analyse impossible : ${detailErreur}`);
      }
    } catch (error: unknown) {
      console.error('Erreur analyse document:', error);
      const message = error instanceof Error ? error.message : String(error);
      if (message.includes('quota') || message.includes('Quota')) {
        setErreurAnalyse('Quota SENTINELLE épuisé. Passez à une formule supérieure pour continuer.');
      } else {
        // Session 215 : message complet pour diagnostic
        setErreurAnalyse(`Erreur lors de l'analyse : ${message}`);
      }
    } finally {
      setAnalyseEnCours(false);
      setEtapeAnalyse('');
    }
  };

  // Session 195 : Archivage document — redirige vers AjouterDocumentVigiePage
  // L'utilisateur valide/corrige le classement dans le tunnel dédié, puis revient dans SENTINELLE.
  const archiverDocument = () => {
    if (!resultatAnalyse) return;
    navigate('/vigie/documents/ajouter', {
      state: {
        fromSentinelle: true,
        resultatAnalyse,
      }
    });
    setResultatAnalyse(null);
    setDoublonDetecte(null);
  };

  // "Archiver quand même" après doublon — Session 135 : centralisation via uploadDocument()
  const confirmerArchivageMalgreDoublon = async () => {
    if (!resultatAnalyse || !coproprieteId || !firebaseUser) return;

    const file = resultatAnalyse.fileOriginal;
    if (!file) {
      // fileOriginal non sérialisable — perdu si la page a été rechargée.
      // Effacer doublon + résultat PUIS afficher l'erreur (ordre critique pour le rendu).
      setDoublonDetecte(null);
      setResultatAnalyse(null);
      setErreurAnalyse("Le fichier original n'est plus disponible. Dépose à nouveau le document pour l'analyser.");
      return;
    }

    setDoublonDetecte(null);
    setResultatAnalyse(null);
    setAnalyseEnCours(true);

    try {
      setEtapeAnalyse('Envoi du document à SENTINELLE...');
      const { url } = await uploadTempFile(file, coproprieteId, firebaseUser.uid);

      setEtapeAnalyse('SENTINELLE analyse le document...');
      const resultat = await analyzeDocument(url, file.name, file.type, coproprieteId);

      if (resultat.success && resultat.suggestion) {
        const { suggestion } = resultat;
        const fileHash = await computeFileHash(file);
        const userNom = `${userProfile?.prenom || ''} ${userProfile?.nom || ''}`.trim();

        // Session 135 : Passage par la porte unique uploadDocument()
        // Session 186 : skipDuplicateCheck = true car l'utilisateur a confirmé "Archiver quand même"
        await uploadDocument({
          coproprieteId,
          titre: suggestion.titre,
          type: suggestion.typeDocument,
          categorie: suggestion.categorie || 'administratif',
          description: suggestion.description || undefined,
          dateDocument: suggestion.dateDocument ? new Date(suggestion.dateDocument) : undefined,
          interlocuteurId: suggestion.interlocuteurId || undefined,
          interlocuteurNom: suggestion.interlocuteurNom || undefined,
          affaireId: suggestion.affaireId || undefined,
          visibilite: 'proprietaire',
          userId: firebaseUser.uid,
          userNom,
          fileHash,
          // Mode B : fichier déjà uploadé dans Storage
          tempFilePath: url,
          fichierNom: file.name,
          fichierTaille: file.size,
          fichierType: file.type,
          // Champs SENTINELLE
          source: 'sentinelle_vigie',
          typeDocumentLabel: suggestion.typeDocumentLabel,
          donneesCles: suggestion.donneesCles || {},
          anomalies: suggestion.anomalies || [],
          analyseSentinelle: {
            confiance: suggestion.confidence,
            explication: suggestion.explication,
            actionsRecommandees: suggestion.actionsRecommandees,
            anomalies: suggestion.anomalies || [],
            donneesCles: suggestion.donneesCles || {},
            dateAnalyse: Timestamp.now()
          },
          // Session 143 : Sens correspondance pour le courrier miroir
          sensCorrespondance: suggestion.sensCorrespondance || null,
          // Session 144 : Intelligence Correspondance — persistance des champs détectés
          courrierId_lie: suggestion.courrierId_lie || undefined,
          courrierRef_lie: suggestion.courrierRef_lie || undefined,
          typeCorrespondance: suggestion.typeCorrespondance || undefined,
          qualiteReponse: suggestion.qualiteReponse || undefined,
          pointsTraites: suggestion.pointsTraites || undefined,
          pointsManquants: suggestion.pointsManquants || undefined,
          alerteQualite: suggestion.alerteQualite || undefined,
          skipDuplicateCheck: true,
        });

        await chargerQuotas();

        // Session 168 : Message post-archivage intelligent (même logique que archivage normal)
        await posterMessagePostArchivage(suggestion.typeDocument, suggestion.donneesCles);
      } else {
        setErreurAnalyse(resultat.error || 'Analyse impossible. Réessayez.');
      }
    } catch (error) {
      console.error('Erreur archivage malgré doublon:', error);
      setErreurAnalyse('Erreur lors de l\'archivage. Réessayez.');
    } finally {
      setAnalyseEnCours(false);
      setEtapeAnalyse('');
    }
  };

  const fermerResultat = async () => {
    if (resultatAnalyse?.filePath) {
      try {
        await deleteTempFile(resultatAnalyse.filePath);
      } catch {
        // Ignorer
      }
    }
    setResultatAnalyse(null);
    setDoublonDetecte(null);
  };

  // ============================================================================
  // SESSION 168 : POST-ARCHIVAGE INTELLIGENT (Principe 10)
  // Détecte si le document complémentaire existe dans la GED
  // et propose automatiquement le calcul des charges récupérables
  // Session 228 : Niveau 3 — détection proactive vérification comptable en cours
  // ============================================================================

  const posterMessagePostArchivage = async (typeDocument: string, donneesCles?: Record<string, any>, dateDocument?: Date) => {
    if (!coproprieteId) return;

    const typesCharges = ['appel_charges', 'releve_charges', 'decompte_charges', 'regularisation_charges', 'releve', 'appel_fonds'];
    const isReglement = typeDocument === 'reglement_copropriete';
    const isCharges = typesCharges.includes(typeDocument);

    // Cas 1 : Règlement avec tantièmes archivé → chercher si appel de charges existe
    if (isReglement && (donneesCles?.lotsPropietaire || donneesCles?.typeTantiemes === 'multi_cles')) {
      try {
        const chargesQuery = query(
          collection(db, 'documents'),
          where('coproprieteId', '==', coproprieteId),
          where('type', 'in', typesCharges)
        );
        const chargesSnap = await getDocs(chargesQuery);

        let postArchiveMsg: ChatMessage;

        if (!chargesSnap.empty) {
          // Appel de charges déjà dans la GED → proposer calcul immédiat
          postArchiveMsg = {
            id: `post_archive_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `J'ai archivé ton règlement de copropriété et j'ai identifié les tantièmes de ton lot pour chaque type de charge. Tu as déjà un relevé de charges dans ta GED — je peux calculer immédiatement tes charges récupérables poste par poste.`,
            suggestionsReponse: ['Calcule mes charges récupérables'],
            actions: []
          };
        } else {
          // Pas d'appel de charges → guider vers l'upload
          postArchiveMsg = {
            id: `post_archive_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `J'ai archivé ton règlement de copropriété et j'ai identifié les tantièmes de ton lot pour chaque type de charge (charges générales, bâtiment, ascenseur, logements). Je peux maintenant analyser tes charges avec précision poste par poste.\n\nUploade ton dernier **relevé de charges** ou **appel de provisions** pour que je calcule ta quote-part exacte.`,
            actions: []
          };
        }

        setChatMessages(prev => {
          const updated = [...prev, postArchiveMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[POST-ARCHIVAGE] Erreur vérification GED:', error);
      }
    }

    // Cas 2 : Appel de charges archivé → chercher si règlement avec tantièmes existe
    if (isCharges) {
      try {
        const reglementQuery = query(
          collection(db, 'documents'),
          where('coproprieteId', '==', coproprieteId),
          where('type', '==', 'reglement_copropriete')
        );
        const reglementSnap = await getDocs(reglementQuery);

        // Vérifier si au moins un règlement a des tantièmes extraits
        const reglementAvecTantiemes = reglementSnap.docs.some(doc => {
          const data = doc.data();
          return data.donneesCles?.lotsPropietaire || data.donneesCles?.typeTantiemes === 'multi_cles';
        });

        let postArchiveMsg: ChatMessage;

        if (reglementAvecTantiemes) {
          // Règlement avec tantièmes déjà dans la GED → proposer calcul immédiat
          postArchiveMsg = {
            id: `post_archive_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `J'ai archivé ton relevé de charges. Avec les tantièmes de ton lot que j'ai déjà extraits de ton règlement de copropriété, je peux calculer immédiatement tes charges récupérables poste par poste.`,
            suggestionsReponse: ['Calcule mes charges récupérables'],
            actions: []
          };
        } else {
          // Pas de règlement avec tantièmes → guider vers l'upload du règlement
          postArchiveMsg = {
            id: `post_archive_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `J'ai archivé ton relevé de charges. Pour calculer précisément tes charges récupérables poste par poste, j'ai besoin des tantièmes de ton lot.\n\nUploade ton **règlement de copropriété** pour que j'en extraie les clés de répartition.`,
            actions: []
          };
        }

        setChatMessages(prev => {
          const updated = [...prev, postArchiveMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[POST-ARCHIVAGE] Erreur vérification GED:', error);
      }
    }

    // ============================================================================
    // SESSION 228 : CAS 3 — NIVEAU 3 INTELLIGENCE COMPTABLE
    // Document comptable archivé → vérifier si une vérification existe pour cet exercice
    // ============================================================================
    if (isCharges) {
      try {
        // Détecter l'exercice depuis les donneesCles ou la date du document
        const anneeDoc = donneesCles?.exercice
          || donneesCles?.anneeExercice
          || (dateDocument ? dateDocument.getFullYear().toString() : null)
          || new Date().getFullYear().toString();

        const verifQuery = query(
          collection(db, 'coproprietes', coproprieteId, 'verifications'),
          where('exercice', '==', anneeDoc)
        );
        const verifSnap = await getDocs(verifQuery);

        let niveau3Msg: ChatMessage;

        if (!verifSnap.empty) {
          // Vérification en cours pour cet exercice → proposer d'y accéder
          const verifDoc = verifSnap.docs[0];
          const verifId = verifDoc.id;
          const verifTitre = verifDoc.data().titre || `Vérification ${anneeDoc}`;

          niveau3Msg = {
            id: `niveau3_verif_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `Ce document peut alimenter ta vérification comptable "${verifTitre}" (exercice ${anneeDoc}). Je l'ai ajouté automatiquement — tu peux consulter l'analyse complète.`,
            suggestionsReponse: [`Voir ma vérification ${anneeDoc}`],
            actions: [{
              id: `action_voir_verif_${Date.now()}`,
              type: 'verifier_comptabilite' as const,
              label: `Voir la vérification ${anneeDoc}`,
              data: { exercice: anneeDoc, verificationId: verifId },
              confidence: 'high' as const,
            }]
          };

        } else {
          // Aucune vérification → proposer d'en créer une
          niveau3Msg = {
            id: `niveau3_creer_verif_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `Ce document de charges (exercice ${anneeDoc}) est maintenant dans ta GED. Tu veux que je lance une vérification comptable pour contrôler tes appels de fonds et détecter d'éventuelles anomalies ?`,
            suggestionsReponse: [`Lancer la vérification ${anneeDoc}`],
            actions: [{
              id: `action_creer_verif_${Date.now()}`,
              type: 'verifier_comptabilite' as const,
              label: `Lancer la vérification ${anneeDoc}`,
              data: { exercice: anneeDoc, titre: `Contrôle comptable ${anneeDoc}` },
              confidence: 'high' as const,
            }]
          };
        }

        setChatMessages(prev => {
          const updated = [...prev, niveau3Msg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[NIVEAU3] Erreur détection vérification:', error);
      }
    }
  };

  // ============================================================================
  // CHAT SENTINELLE
  // ============================================================================

  const envoyerMessageChat = async (message: string) => {
    if (!message.trim() || chatLoading || !coproprieteId) return;

    // Session 141 : Utilise ChatMessage au lieu de ChatMessageLocal
    const userMsg: ChatMessage = {
      id: `msg_${Date.now()}_user`,
      role: 'user',
      content: message.trim(),
      timestamp: new Date(),
    };
    setChatMessages(prev => [...prev, userMsg]);
    setChatInput('');
    setChatLoading(true);
    setChatError(null);

    try {
      const conversationHistory = chatMessages.map(m => ({
        role: m.role as 'user' | 'assistant',
        content: m.content,
      }));

      // Session 259 : affaireId passé si contexte dossier — SENTINELLE voit le contenu des documents rattachés
      const result: AssistantResult = await askAssistant(
        message.trim(),
        conversationHistory,
        coproprieteId,
        contexteDossier?.id || undefined
      );

      const assistantMsg: ChatMessage = {
        id: `msg_${Date.now()}_assistant`,
        role: 'assistant',
        content: result.message,
        timestamp: new Date(),
        actions: result.actions,
        incitationPieces: result.incitationPieces,
        suggestionsReponse: result.suggestionsReponse,
        // Session 216 : courrier transmis pour que handleAction lise le contenu complet via msg.courrier
        ...(result.courrier && { courrier: result.courrier }),
      };

      // Session 141 : Mise à jour state + sauvegarde Firestore en une fois
      setChatMessages(prev => {
        const updated = [...prev, assistantMsg];
        // Sauvegarde async (ne bloque pas le rendu)
        sauvegarderConversation(updated, conversationId);
        return updated;
      });
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Erreur inattendue';
      if (errorMessage.includes('quota') || errorMessage.includes('Quota')) {
        setChatError('Quota SENTINELLE épuisé. Passez à une formule supérieure.');
      } else {
        setChatError('Erreur de communication avec SENTINELLE. Réessayez.');
      }
    } finally {
      setChatLoading(false);
    }
  };

  const handleChatKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      envoyerMessageChat(chatInput);
    }
  };

  // Session 121 : Détection intelligente du type de destinataire depuis le nom
  const detecterDestinataire = (data: any): string => {
    // Si SENTINELLE a déjà fourni un type explicite et valide, le respecter
    const typeExplicite = data?.destinataireType;
    if (typeExplicite && typeExplicite !== 'autre') return typeExplicite;

    // Détection automatique depuis le nom du destinataire
    const nom = (data?.destinataireNom || data?.destinataire || '').toLowerCase();
    if (!nom) return 'autre';

    // Promoteur / constructeur
    if (nom.includes('kic') || nom.includes('kieken') || nom.includes('promoteur') || nom.includes('constructeur')) {
      return 'promoteur';
    }
    // Syndic
    if (nom.includes('syndic') || nom.includes('square habitat') || nom.includes('foncia') || nom.includes('nexity') || nom.includes('citya')) {
      return 'syndic';
    }
    // Assurance
    if (nom.includes('assur') || nom.includes('maif') || nom.includes('maaf') || nom.includes('axa') || nom.includes('allianz') || nom.includes('dommages-ouvrage')) {
      return 'assurance';
    }
    // Mairie / collectivité
    if (nom.includes('mairie') || nom.includes('préfecture') || nom.includes('commune') || nom.includes('métropole')) {
      return 'administration';
    }
    // Expert / bureau d'études
    if (nom.includes('expert') || nom.includes('bureau') || nom.includes('diagnostiqu')) {
      return 'expert';
    }

    return 'autre';
  };

  // Gestion des actions proposées par SENTINELLE
  // Session 122 : Extraction robuste du nom destinataire — ne plus passer l'ID Firestore
  const extraireNomDestinataire = (data: any, actionLabel: string): string => {
    // Priorité 1 : champ explicite destinataireNom (texte lisible)
    if (data?.destinataireNom && !data.destinataireNom.match(/^[a-zA-Z0-9]{15,}$/)) {
      return data.destinataireNom;
    }
    // Priorité 2 : champ destinataire (si c'est un nom lisible, pas un ID Firestore)
    if (data?.destinataire && !data.destinataire.match(/^[a-zA-Z0-9]{15,}$/)) {
      return data.destinataire;
    }
    // Priorité 3 : extraire du label de l'action (ex: "Envoyer l'email au promoteur KIC")
    // On cherche après "à" ou "au" dans le label
    const matchLabel = actionLabel?.match(/(?:à|au)\s+(?:le\s+|la\s+|l')?(?:promoteur|syndic|constructeur|assureur|expert)?\s*(.+)/i);
    if (matchLabel?.[1]) {
      return matchLabel[1].trim();
    }
    // Priorité 4 : le label complet comme fallback
    return '';
  };

  // Session 182 : Nettoyage markdown dans le contenu courrier
  // SENTINELLE génère du markdown (**gras**, *italique*) mais le formulaire courrier affiche du texte brut
  const nettoyerMarkdownCourrier = (contenu: string): string => {
    if (!contenu) return '';
    return contenu
      .replace(/\*\*(.+?)\*\*/g, '$1')   // **gras** → gras
      .replace(/\*(.+?)\*/g, '$1')        // *italique* → italique
      .replace(/^#{1,3}\s+/gm, '')        // ### Titre → Titre
      .replace(/^- /gm, '– ')             // - liste → – liste (tiret cadratin)
      .trim();
  };

  // Session 182 : Détection intelligente du type de courrier depuis le contenu/objet
  // Évite le fallback systématique sur 'demande_information'
  const detecterTypeCourrier = (objet: string, contenu: string): string => {
    const texte = `${objet} ${contenu}`.toLowerCase();
    // Notification : régularisation, ajustement, information formelle, avis
    if (texte.includes('régularisation') || texte.includes('regularisation')
      || texte.includes('ajustement') || texte.includes('avis de')
      || texte.includes('notification') || texte.includes('vous informe')
      || texte.includes('je vous notifie') || texte.includes('décompte')) {
      return 'notification';
    }
    // Réclamation : préjudice, désordre, défaut, non-conformité
    if (texte.includes('réclamation') || texte.includes('reclamation')
      || texte.includes('préjudice') || texte.includes('désordre')
      || texte.includes('non-conformité') || texte.includes('défaut')
      || texte.includes('malfaçon') || texte.includes('sinistre')) {
      return 'reclamation';
    }
    // Relance : rappel, relance, sans réponse, suite à mon courrier
    if (texte.includes('relance') || texte.includes('rappel')
      || texte.includes('sans réponse') || texte.includes('suite à mon')
      || texte.includes('réitère') || texte.includes('renouvelle ma demande')) {
      return 'relance';
    }
    // Mise en demeure
    if (texte.includes('mise en demeure') || texte.includes('dernier délai')
      || texte.includes('sommation') || texte.includes('ultime')) {
      return 'mise_en_demeure';
    }
    // Compte rendu
    if (texte.includes('compte rendu') || texte.includes('compte-rendu')
      || texte.includes('procès-verbal') || texte.includes('constat')) {
      return 'compte_rendu';
    }
    // Demande d'information (cas par défaut, mais seulement si c'est vraiment une demande)
    return 'demande_information';
  };

  // Session 215 : sourceCourrier optionnel — double sécurité contre la troncature
  // msg.courrier (ChatMessage.courrier) est prioritaire sur action.data.contenu
  const handleAction = async (action: ProposedAction, sourceCourrier?: CourrierGenere) => {
    if (action.type === 'generate_courrier') {
      const d = action.data as any;
      const nomDestinataire = extraireNomDestinataire(d, action.label);
      // Session 134 : Résolution affaireId — 3 sources par priorité :
      // 1. Dossier parent du signalement (contexte signalement)
      // 2. Dossier courant (contexte dossier direct)
      // 3. affaireId fourni par SENTINELLE dans action.data
      const affaireIdResolue = affaireIdPourSignalement || contexteDossier?.id || d?.affaireId || null;
      // Session 215 : contenu depuis sourceCourrier (jamais tronqué) ou action.data en fallback
      const contenuFinal = sourceCourrier?.contenu || d?.contenu || '';
      const objetFinal = sourceCourrier?.objet || d?.objet || '';
      navigate('/vigie/courriers/nouveau', {
        state: {
          fromSentinelle: true,
          prefill: {
            objet: objetFinal,
            contenu: nettoyerMarkdownCourrier(contenuFinal),
            type: d?.type || detecterTypeCourrier(objetFinal, contenuFinal),
            destinataire: nomDestinataire,
            destinataireType: detecterDestinataire({ ...d, destinataireNom: nomDestinataire, destinataire: nomDestinataire }),
            modeEnvoi: (['email', 'postal', 'lrar', 'recommande_ar'].includes(d?.modeEnvoiSuggere) ? d.modeEnvoiSuggere : 'email'),
            // Session 134 : Rattachement automatique — toutes sources
            ...(contexteSignalement?.id && { signalementId: contexteSignalement.id }),
            ...(affaireIdResolue && { affaireId: affaireIdResolue }),
            // Session 160 : CC suggérés par SENTINELLE
            ...(Array.isArray(d?.destinatairesCC) && d.destinatairesCC.length > 0 && { destinatairesCC: d.destinatairesCC }),
            // Session 292 : Email du signataire du document source (priorité sur contact principal)
            ...(d?.destinataireEmail && { destinataireEmail: d.destinataireEmail }),
          }
        }
      });
    } else if (action.type === 'send_email') {
      const d = action.data as any;
      const nomDestinataire = extraireNomDestinataire(d, action.label);
      // Session 134 : Même résolution affaireId que generate_courrier
      const affaireIdResolue = affaireIdPourSignalement || contexteDossier?.id || d?.affaireId || null;
      // Session 215 : contenu depuis sourceCourrier (jamais tronqué) ou action.data en fallback
      const contenuFinal2 = sourceCourrier?.contenu || d?.contenu || '';
      const objetFinal2 = sourceCourrier?.objet || d?.objet || '';
      navigate('/vigie/courriers/nouveau', {
        state: {
          fromSentinelle: true,
          prefill: {
            objet: objetFinal2,
            contenu: nettoyerMarkdownCourrier(contenuFinal2),
            type: d?.type || detecterTypeCourrier(objetFinal2, contenuFinal2),
            destinataire: nomDestinataire,
            destinataireType: detecterDestinataire({ ...d, destinataireNom: nomDestinataire, destinataire: nomDestinataire }),
            modeEnvoi: 'email',
            // Session 134 : Rattachement automatique — toutes sources
            ...(contexteSignalement?.id && { signalementId: contexteSignalement.id }),
            ...(affaireIdResolue && { affaireId: affaireIdResolue }),
            // Session 160 : CC suggérés par SENTINELLE
            ...(Array.isArray(d?.destinatairesCC) && d.destinatairesCC.length > 0 && { destinatairesCC: d.destinatairesCC }),
            // Session 292 : Email du signataire du document source (priorité sur contact principal)
            ...(d?.destinataireEmail && { destinataireEmail: d.destinataireEmail }),
          }
        }
      });
    } else if (action.type === 'create_signalement') {
      // Session 235 : create_signalement redirige vers create_affaire — signalement supprimé en VIGIE
      // On mappe les champs signalement → dossier (titre, description conservés)
      const d = action.data as any;
      const params = new URLSearchParams();
      if (d?.titre) params.set('titre', d.titre);
      if (d?.description) params.set('description', d.description);
      if (d?.categorie) params.set('type', d.categorie);
      const queryString = params.toString();
      navigate(`/vigie/dossiers/nouveau${queryString ? '?' + queryString : ''}`);
    } else if (action.type === 'create_affaire') {
      const d = action.data as any;
      // Construire les URL params pour le pré-remplissage du formulaire dossier
      const params = new URLSearchParams();
      if (d?.titre) params.set('titre', d.titre);
      if (d?.type) params.set('type', d.type);
      if (d?.description) params.set('description', d.description);
      if (d?.priorite) params.set('priorite', d.priorite);
      if (d?.garantie) params.set('garantie', d.garantie);
      const queryString = params.toString();
      navigate(`/vigie/dossiers/nouveau${queryString ? '?' + queryString : ''}`);
    } else if (action.type === 'update_paiement') {
      // Session 136 : Mise à jour statutPaiement via chat SENTINELLE
      const d = action.data as any;
      if (!d?.documentId) {
        console.warn('[SENTINELLE] update_paiement sans documentId');
        return;
      }
      try {
        const docRef = doc(db, 'documents', d.documentId);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
          console.warn('[SENTINELLE] Document introuvable:', d.documentId);
          return;
        }
        const existingDonneesCles = (docSnap.data().donneesCles || {}) as Record<string, string>;
        await updateDoc(docRef, {
          donneesCles: {
            ...existingDonneesCles,
            statutPaiement: 'oui',
            datePaiement: d.datePaiement || new Date().toISOString().split('T')[0],
            modePaiement: d.modePaiement || '',
            referencePaiement: d.reference || ''
          },
          updatedAt: Timestamp.now()
        });
        // Confirmation dans le chat
        const confirmMsg: ChatMessage = {
          id: `paiement_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Paiement enregistré. Le document "${existingDonneesCles.titre || docSnap.data().nom || 'Appel de fonds'}" est maintenant marqué comme réglé (${d.modePaiement || 'mode non précisé'}${d.datePaiement ? ', le ' + new Date(d.datePaiement).toLocaleDateString('fr-FR') : ''}). Ton tableau de bord sera mis à jour automatiquement.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur update_paiement:', error);
        const errMsg: ChatMessage = {
          id: `paiement_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de l'enregistrement du paiement. Réessaie ou marque-le directement depuis ton tableau de bord.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'update_profil_tantiemes') {
      // Session 166 : Mise à jour des clés de répartition extraites du règlement de copropriété
      // Session 244 : Corrections critiques —
      //   1. Écriture sur coproprietes.lots (racine) et non onboardingData.lots
      //      (DashboardVigiePage et contextBuilder lisent copropriete.lots)
      //   2. Écriture de totalTantiemes depuis denominateurGeneral (extrait par SENTINELLE)
      //   3. Fusion par numeroLot en priorité, puis par index si pas de numéro
      //   4. Zéro fallback numérique — si denominateurGeneral absent, on n'écrit pas totalTantiemes
      const d = action.data as any;
      if (!coproprieteId || !d?.lots || !Array.isArray(d.lots) || d.lots.length === 0) {
        console.warn('[SENTINELLE] update_profil_tantiemes : données manquantes ou lots vide');
        return;
      }
      try {
        const coproRef = doc(db, 'coproprietes', coproprieteId);
        const coproSnap = await getDoc(coproRef);
        if (!coproSnap.exists()) {
          console.warn('[SENTINELLE] Copropriété introuvable:', coproprieteId);
          return;
        }
        const coproData = coproSnap.data();

        // Source de vérité : coproprietes.lots (racine), pas onboardingData.lots
        const existingLots: any[] = Array.isArray(coproData?.lots) ? coproData.lots : [];

        let updatedLots: any[];

        if (existingLots.length === 0) {
          // Pas de lots existants → utiliser directement les lots extraits du règlement
          updatedLots = d.lots;
        } else {
          // Fusionner : priorité au match par numeroLot, sinon par index (1er lot = lot du propriétaire)
          // Bug 1 fix (session 248) : après fusion, ajouter les lots SENTINELLE sans correspondant existant
          const lotsDejaFusionnes = new Set<string>();

          updatedLots = existingLots.map((existingLot: any, index: number) => {
            // Tentative 1 : match par numéro de lot (le plus fiable)
            let matchingLot = d.lots.find((newLot: any) =>
              newLot.numeroLot !== undefined &&
              existingLot.numeroLot !== undefined &&
              String(newLot.numeroLot) === String(existingLot.numeroLot)
            );
            // Tentative 2 : match par index (utilisateur n'a souvent qu'un lot dans son profil)
            if (!matchingLot && d.lots[index]) {
              matchingLot = d.lots[index];
            }
            if (matchingLot) {
              if (matchingLot.numeroLot !== undefined) {
                lotsDejaFusionnes.add(String(matchingLot.numeroLot));
              }
              return {
                ...existingLot,
                ...(matchingLot.numeroLot !== undefined && { numeroLot: matchingLot.numeroLot }),
                ...(matchingLot.tantiemes !== undefined && { tantiemes: matchingLot.tantiemes }),
                ...(matchingLot.etage !== undefined && { etage: matchingLot.etage }),
                ...(Array.isArray(matchingLot.clesRepartition) && matchingLot.clesRepartition.length > 0
                  && { clesRepartition: matchingLot.clesRepartition }),
              };
            }
            return existingLot;
          });

          // Ajouter les lots SENTINELLE qui n'ont pas trouvé de correspondant dans existingLots
          // (cas typique : utilisateur a plusieurs lots mais seul le 1er était en base)
          const lotsSupplementaires = d.lots.filter((newLot: any) =>
            newLot.numeroLot !== undefined &&
            !lotsDejaFusionnes.has(String(newLot.numeroLot))
          );
          if (lotsSupplementaires.length > 0) {
            updatedLots = [...updatedLots, ...lotsSupplementaires];
          }
        }

        // Construire la mise à jour Firestore
        const updatePayload: Record<string, any> = {
          lots: updatedLots,
          updatedAt: Timestamp.now()
        };

        // Écrire totalTantiemes uniquement si SENTINELLE a extrait le dénominateur
        // Zéro fallback — si absent, le dashboard affiche "Non renseigné" plutôt qu'une valeur fausse
        const denominateur = d.denominateurGeneral !== undefined
          ? parseInt(String(d.denominateurGeneral), 10)
          : null;
        if (denominateur !== null && !isNaN(denominateur) && denominateur > 0) {
          updatePayload.totalTantiemes = denominateur;
        }

        await updateDoc(coproRef, updatePayload);

        // Bug 1 fix (session 248) : rafraîchir le contexte copropriété pour que le dashboard
        // reflète immédiatement les nouveaux tantièmes sans rechargement de page
        await refreshCopropriete();

        // Confirmation dans le chat — Principe 10 : valeur utilisateur
        const confirmMsg: ChatMessage = {
          id: `tantiemes_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `C'est enregistré. Je connais maintenant la répartition précise de tes charges par poste. Les prochains calculs seront ventilés correctement — y compris l'exemption ascenseur si ton lot est au RDC.\n\nUploade ton dernier **relevé de charges** pour que je fasse le calcul.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur update_profil_tantiemes:', error);
        const errMsg: ChatMessage = {
          id: `tantiemes_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de la mise à jour des tantièmes. Réessaie ou contacte le support.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'create_evenement') {
      // Session 146 : Création événement calendrier depuis chat SENTINELLE
      const d = action.data as any;
      if (!coproprieteId) {
        console.warn('[SENTINELLE] create_evenement sans coproprieteId');
        return;
      }
      try {
        // Parser la date — SENTINELLE fournit une date ISO ou texte
        let dateEcheance: Date;
        if (d?.date) {
          dateEcheance = new Date(d.date);
          if (isNaN(dateEcheance.getTime())) {
            dateEcheance = new Date(); // Fallback aujourd'hui
            dateEcheance.setDate(dateEcheance.getDate() + 7); // +7 jours par défaut
          }
        } else {
          dateEcheance = new Date();
          dateEcheance.setDate(dateEcheance.getDate() + 7);
        }

        await creerEcheance({
          coproprieteId,
          titre: d?.titre || action.label || 'Échéance SENTINELLE',
          description: d?.description || '',
          dateEcheance: Timestamp.fromDate(dateEcheance),
          source: 'manuelle',
          sourceLabel: 'SENTINELLE',
          terminee: false,
        });

        // Confirmation dans le chat
        const confirmMsg: ChatMessage = {
          id: `evenement_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Échéance créée : "${d?.titre || action.label}" programmée au ${dateEcheance.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}. Tu la retrouveras dans ton calendrier.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur create_evenement:', error);
        const errMsg: ChatMessage = {
          id: `evenement_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de la création de l'échéance. Tu peux la créer manuellement depuis ton calendrier.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'create_paiement_bailleur') {
      // Session 218 : Enregistrement automatique d'un paiement locataire depuis une quittance GED
      const d = action.data as any;
      if (!firebaseUser || !d?.locataireId || !d?.moisConcerne) {
        console.warn('[SENTINELLE] create_paiement_bailleur : données manquantes', d);
        return;
      }
      try {
        const [annee, mois] = (d.moisConcerne as string).split('-');
        const moisLabel = (annee && mois)
          ? new Date(parseInt(annee), parseInt(mois) - 1, 1)
              .toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
          : d.moisConcerne;

        await createPaiement(firebaseUser.uid, d.locataireId, {
          type: d.type || 'loyer',
          montantAttendu: d.montantAttendu || 0,
          montantRecu: d.montantRecu !== undefined ? d.montantRecu : (d.montantAttendu || 0),
          moisConcerne: d.moisConcerne,
          note: d.note || 'Créé depuis quittance archivée en GED',
        });

        const confirmMsg: ChatMessage = {
          id: 'paiement_bailleur_ok_' + Date.now(),
          role: 'assistant' as const,
          timestamp: new Date(),
          content: 'Paiement de ' + (d.locataireNom || 'ton locataire') + ' enregistré pour ' + moisLabel + ' — ' + (d.montantAttendu || 0) + '€. Tu le retrouveras dans ton suivi bailleur.',
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur create_paiement_bailleur:', error);
        const errMsg: ChatMessage = {
          id: 'paiement_bailleur_err_' + Date.now(),
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de l'enregistrement du paiement. Tu peux l'ajouter manuellement depuis ton suivi bailleur.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'verifier_comptabilite') {
      // Session 227 : Niveau 2 — Lancement vérification comptable depuis chat SENTINELLE
      // Session 228 : Niveau 3 — si verificationId présent → navigation directe (vérification existante)
      const d = action.data as any;
      if (!coproprieteId || !firebaseUser || !userProfile) {
        console.warn('[SENTINELLE] verifier_comptabilite : contexte manquant');
        return;
      }
      try {
        const exercice = d?.exercice || new Date().getFullYear().toString();

        // Niveau 3 : vérification existante → navigation directe sans createVerification
        if (d?.verificationId) {
          navigate(`/vigie/comptabilite/${d.verificationId}`);
          return;
        }

        const userName = userProfile.prenom
          ? `${userProfile.prenom} ${userProfile.nom || ''}`.trim()
          : userProfile.email || 'Utilisateur';

        const titre = d?.titre || undefined;

        const verificationId = await createVerification(
          {
            coproprieteId,
            exercice,
            titre,
          },
          firebaseUser.uid,
          userName
        );

        // Confirmation dans le chat avant navigation
        const confirmMsg: ChatMessage = {
          id: `verif_comptable_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Vérification comptable créée pour la période ${exercice}. Je vais chercher tes documents comptables dans ta GED et te proposer de les analyser automatiquement.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });

        // Navigation vers la page de détail — le Niveau 1 prend le relais
        setTimeout(() => {
          navigate(`/vigie/comptabilite/${verificationId}`);
        }, 800);

      } catch (error) {
        console.error('[SENTINELLE] Erreur verifier_comptabilite:', error);
        const errMsg: ChatMessage = {
          id: `verif_comptable_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de la création de la vérification. Tu peux la créer manuellement depuis Ma comptabilité.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'update_profil_bailleur') {
      // Session 228 : Activation mode bailleur depuis chat SENTINELLE
      // Pose estBailleur:true sur users/{uid} — déverrouille la sidebar "Mon suivi bailleur"
      if (!firebaseUser) {
        console.warn('[SENTINELLE] update_profil_bailleur : firebaseUser manquant');
        return;
      }
      try {
        const userRef = doc(db, 'users', firebaseUser.uid);
        await updateDoc(userRef, { estBailleur: true });

        const confirmMsg: ChatMessage = {
          id: `bailleur_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Ton profil bailleur est activé. Tu as maintenant accès a **Mon suivi bailleur** dans le menu — tu peux y ajouter tes locataires et suivre tes paiements.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });

        // Recharger le profil pour que la sidebar se mette a jour immédiatement
        setTimeout(() => window.location.reload(), 1500);

      } catch (error) {
        console.error('[SENTINELLE] Erreur update_profil_bailleur:', error);
        const errMsg: ChatMessage = {
          id: `bailleur_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de l'activation du mode bailleur. Réessaie dans quelques instants.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'create_interlocuteur') {
      // Session 154 : Création d'un interlocuteur depuis le chat SENTINELLE
      // Utilise createInterlocuteur du service (même structure que ContactsVigiePage)
      const d = action.data as any;
      if (!coproprieteId) {
        console.warn('[SENTINELLE] create_interlocuteur sans coproprieteId');
        return;
      }
      try {
        const nomComplet = [d?.prenom, d?.nom].filter(Boolean).join(' ') || 'Contact';

        // Construire le contact principal (personne physique)
        const contactPrincipal: Record<string, any> = {
          nom: d?.nom || nomComplet,
          principal: true,
        };
        if (d?.prenom) contactPrincipal.prenom = d.prenom;
        if (d?.fonction) contactPrincipal.fonction = d.fonction;
        if (d?.email) contactPrincipal.email = d.email;
        if (d?.telephone) contactPrincipal.telephone = d.telephone;

        // Créer via le service interlocuteur (structure raisonSociale + contacts[])
        const { createInterlocuteur } = await import('../../services/interlocuteur.service');
        await createInterlocuteur({
          coproprieteId,
          type: d?.type || 'autre',
          raisonSociale: d?.societe || nomComplet,
          contacts: [contactPrincipal],
          actif: true,
        } as any);

        // Confirmation dans le chat
        const confirmMsg: ChatMessage = {
          id: `interlocuteur_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Contact ajouté : ${nomComplet}${d?.fonction ? ' — ' + d.fonction : ''}. Tu le retrouveras dans Mes contacts.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur create_interlocuteur:', error);
        const errMsg: ChatMessage = {
          id: `interlocuteur_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de la création du contact. Tu peux l'ajouter manuellement depuis Mes contacts.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'update_affaire') {
      // Session 248 : Mise à jour d'un dossier depuis le chat SENTINELLE (Bug 2 fix)
      const d = action.data as any;
      if (!d?.affaireId) {
        console.warn('[SENTINELLE] update_affaire : affaireId manquant');
        return;
      }
      try {
        const updateData: UpdateAffaireData = {};
        if (d.titre) updateData.titre = d.titre;
        if (d.statut) updateData.statut = d.statut;
        if (d.priorite) updateData.priorite = d.priorite;
        if (d.description) updateData.description = d.description;
        if (d.montantEstime !== undefined) updateData.montantEstime = d.montantEstime;
        await updateAffaire(d.affaireId, updateData);
        if (d.noteEvenement && userProfile) {
          await addEvenementToAffaire(d.affaireId, {
            type: 'note',
            titre: d.noteEvenement,
            auteurId: userProfile.id,
            auteurNom: `${userProfile.prenom} ${userProfile.nom || ''}`.trim()
          });
        }
        const confirmMsg: ChatMessage = {
          id: `affaire_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Le dossier a été mis à jour.${d.noteEvenement ? ` L'événement "${d.noteEvenement}" a été ajouté à la chronologie.` : ''}`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur update_affaire:', error);
        const errMsg: ChatMessage = {
          id: `affaire_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors de la mise à jour du dossier. Tu peux le modifier manuellement depuis Mes dossiers.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'rattacher_document_affaire') {
      // Session 250 : Rattachement intelligent document → dossier via affaire.service
      // Session 251 : Nettoyage IDs — strip préfixes DOC:/COU: et résolution AFF-xxx → ID Firestore
      const d = action.data as any;
      if (!d?.documentId || !d?.affaireId) {
        console.warn('[SENTINELLE] rattacher_document_affaire : données manquantes', d);
        return;
      }
      try {
        const userNom = `${userProfile?.prenom || ''} ${userProfile?.nom || ''}`.trim() || 'SENTINELLE';

        // Nettoyer documentId : strip préfixe "DOC:" si présent
        const documentIdNettoye = d.documentId.startsWith('DOC:')
          ? d.documentId.slice(4)
          : d.documentId;

        // Résoudre affaireId : si c'est un numéro AFF-xxxx, chercher le vrai ID Firestore
        let affaireIdResolu = d.affaireId;
        if (d.affaireId.startsWith('AFF-') || d.affaireId.startsWith('[AFF:')) {
          const numeroNettoye = d.affaireId.replace('[AFF:', '').replace(']', '');
          const affairesQ = query(
            collection(db, 'affaires'),
            where('coproprieteId', '==', coproprieteId),
            where('numero', '==', numeroNettoye)
          );
          const affairesSnap = await getDocs(affairesQ);
          if (!affairesSnap.empty) {
            affaireIdResolu = affairesSnap.docs[0].id;
          } else {
            console.warn('[SENTINELLE] rattacher_document_affaire : affaire introuvable pour numéro', numeroNettoye);
          }
        } else if (d.affaireId.startsWith('AFF:')) {
          affaireIdResolu = d.affaireId.slice(4);
        }

        // Session 260 : Si documentTitre absent, lire le titre réel depuis Firestore
        let titreFinal = d.documentTitre || '';
        if (!titreFinal) {
          try {
            const docSnap = await getDoc(doc(db, 'documents', documentIdNettoye));
            if (docSnap.exists()) {
              titreFinal = docSnap.data().titre || 'Le document';
            } else {
              titreFinal = 'Le document';
            }
          } catch {
            titreFinal = 'Le document';
          }
        }

        await rattacherDocument(
          affaireIdResolu,
          documentIdNettoye,
          titreFinal,
          firebaseUser?.uid || '',
          userNom
        );
        const confirmMsg: ChatMessage = {
          id: `rattachement_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `"${titreFinal}" est maintenant rattaché à ton dossier. Tu le retrouveras directement depuis la fiche du dossier.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur rattacher_document_affaire:', error, '| documentId=', d.documentId, '| affaireId=', d.affaireId);
        const errMsg: ChatMessage = {
          id: `rattachement_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors du rattachement. Tu peux le faire manuellement depuis la fiche du dossier (bouton \"Rattacher un document\").",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'rattacher_courrier_affaire') {
      // Session 250 : Rattachement intelligent courrier → dossier via affaire.service
      // Session 251 : Nettoyage IDs — strip préfixes COU: et résolution AFF-xxx → ID Firestore
      const d = action.data as any;
      if (!d?.courrierId || !d?.affaireId) {
        console.warn('[SENTINELLE] rattacher_courrier_affaire : données manquantes', d);
        return;
      }
      try {
        const userNom = `${userProfile?.prenom || ''} ${userProfile?.nom || ''}`.trim() || 'SENTINELLE';

        // Nettoyer courrierId : strip préfixe "COU:" si présent
        const courrierIdNettoye = d.courrierId.startsWith('COU:')
          ? d.courrierId.slice(4)
          : d.courrierId;

        // Résoudre affaireId : si c'est un numéro AFF-xxxx, chercher le vrai ID Firestore
        let affaireIdResolu = d.affaireId;
        if (d.affaireId.startsWith('AFF-') || d.affaireId.startsWith('[AFF:')) {
          const numeroNettoye = d.affaireId.replace('[AFF:', '').replace(']', '');
          const affairesQ = query(
            collection(db, 'affaires'),
            where('coproprieteId', '==', coproprieteId),
            where('numero', '==', numeroNettoye)
          );
          const affairesSnap = await getDocs(affairesQ);
          if (!affairesSnap.empty) {
            affaireIdResolu = affairesSnap.docs[0].id;
          } else {
            console.warn('[SENTINELLE] rattacher_courrier_affaire : affaire introuvable pour numéro', d.affaireId);
          }
        } else if (d.affaireId.startsWith('AFF:')) {
          affaireIdResolu = d.affaireId.slice(4);
        }

        await rattacherCourrier(
          affaireIdResolu,
          courrierIdNettoye,
          d.courrierObjet || 'Courrier',
          firebaseUser?.uid || '',
          userNom
        );

        const confirmMsg: ChatMessage = {
          id: `rattachement_courrier_ok_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `"${d.courrierObjet || 'Le courrier'}" est maintenant rattaché à ton dossier. Tu le retrouveras directement depuis la fiche du dossier.`,
          actions: []
        };        setChatMessages(prev => {
          const updated = [...prev, confirmMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur rattacher_courrier_affaire:', error);
        const errMsg: ChatMessage = {
          id: `rattachement_courrier_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: "Erreur lors du rattachement. Tu peux le faire manuellement depuis la fiche du courrier.",
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    } else if (action.type === 'archive_document') {
      // Session 261 : Lister les documents non rattachés à un dossier
      // Handler du bouton "Rattacher les documents éparpillés" généré par SENTINELLE
      // Requête Firestore → documents sans affaireId → message assistant avec liste + invitation à préciser le dossier cible
      if (!coproprieteId) {
        console.warn('[SENTINELLE] archive_document : coproprieteId manquant');
        return;
      }
      try {
        const docsQuery = query(
          collection(db, 'documents'),
          where('coproprieteId', '==', coproprieteId),
          where('visibilite', '==', 'proprietaire')
        );
        const docsSnap = await getDocs(docsQuery);

        // Filtrer côté client : documents sans affaireId
        const docsEparpilles = docsSnap.docs
          .filter(d => {
            const data = d.data();
            return !data.affaireId || data.affaireId === '';
          })
          .slice(0, 5); // Max 5 pour ne pas submerger

        if (docsEparpilles.length === 0) {
          const confirmMsg: ChatMessage = {
            id: `docs_eparpilles_vide_${Date.now()}`,
            role: 'assistant' as const,
            timestamp: new Date(),
            content: `Tous tes documents sont déjà rattachés à un dossier. Ta GED est bien organisée.`,
            actions: []
          };
          setChatMessages(prev => {
            const updated = [...prev, confirmMsg];
            sauvegarderConversation(updated, conversationId);
            return updated;
          });
          return;
        }

        // Construire la liste markdown des documents trouvés
        const lignes = docsEparpilles.map((d, i) => {
          const data = d.data();
          const titre = data.titre || data.fichierNom || 'Document sans titre';
          const type = data.typeDocumentLabel || data.type || '';
          return `${i + 1}. **${titre}**${type ? ` — ${type}` : ''}`;
        }).join('\n');

        const nbTotal = docsSnap.docs.filter(d => {
          const data = d.data();
          return !data.affaireId || data.affaireId === '';
        }).length;

        const intro = nbTotal > 5
          ? `J'ai trouvé **${nbTotal} documents** non rattachés à un dossier. Voici les 5 premiers :`
          : `J'ai trouvé **${nbTotal} document${nbTotal > 1 ? 's' : ''}** non rattaché${nbTotal > 1 ? 's' : ''} à un dossier :`;

        const listeMsg: ChatMessage = {
          id: `docs_eparpilles_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `${intro}\n\n${lignes}\n\nDis-moi à quel dossier tu veux rattacher chacun de ces documents — je m'en occupe.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, listeMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      } catch (error) {
        console.error('[SENTINELLE] Erreur archive_document (liste éparpillés):', error);
        const errMsg: ChatMessage = {
          id: `docs_eparpilles_err_${Date.now()}`,
          role: 'assistant' as const,
          timestamp: new Date(),
          content: `Erreur lors de la récupération de tes documents. Tu peux les consulter et les rattacher manuellement depuis Mes documents.`,
          actions: []
        };
        setChatMessages(prev => {
          const updated = [...prev, errMsg];
          sauvegarderConversation(updated, conversationId);
          return updated;
        });
      }
    }
  };

  // Session 141 : Reset chat + suppression conversation Firestore
  const resetChat = async () => {
    // Nettoyage fichier temporaire si résultat en cours
    if (resultatAnalyse?.filePath) {
      try {
        await deleteTempFile(resultatAnalyse.filePath);
      } catch {
        // Ignorer
      }
    }

    // Session 141 : Supprimer la conversation Firestore
    if (conversationId && coproprieteId) {
      try {
        await deleteConversation(coproprieteId, conversationId);
      } catch (error) {
        console.error('[SENTINELLE] Erreur suppression conversation:', error);
      }
    }

    // Reset complet — Session 121 : vrai clean slate
    setChatMessages([]);
    setChatError(null);
    setResultatAnalyse(null);
    setErreurAnalyse(null);
    setDoublonDetecte(null);
    setAnalyseEnCours(false);
    setEtapeAnalyse('');
    // Session 126 : Reset contexte dossier
    setContexteDossier(null);
    setContexteInjecte(false);
    // Session 128 : Reset contexte signalement
    setContexteSignalement(null);
    setContexteSignalementInjecte(false);
    setAffaireIdPourSignalement(null);
    // Session 141 : Reset conversation ID
    setConversationId(null);
    // Session 260 : Remettre conversationLoaded à false — au retour sur la page,
    // getActiveConversation trouvera null (conversation supprimée) et n'affichera rien
    setConversationLoaded(false);
  };

  // --- Callbacks onboarding ---
  const handleOnboardingComplete = () => {
    setOnboardingComplete(true);
  };

  const handleOnboardingSkip = () => {
    setOnboardingComplete(true);
  };

  // ============================================================================
  // CALCULS DÉRIVÉS
  // ============================================================================

  const quotaRestant = quota ? quota.analysesMax - quota.analysesUtilisees : null;
  const alerteQuota = quotaRestant !== null && quotaRestant <= 5;
  const quotaEpuise = quotaRestant !== null && quotaRestant <= 0;

  // ============================================================================
  // RENDU
  // ============================================================================

  // Écran de chargement initial
  if (onboardingLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-3" />
          <p className="text-gray-500">Chargement de SENTINELLE...</p>
        </div>
      </div>
    );
  }

  if (!coproprieteId) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Sparkles className="w-10 h-10 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500">Impossible de charger SENTINELLE</p>
          <p className="text-sm text-gray-400 mt-1">Votre espace n'est pas encore configuré.</p>
        </div>
      </div>
    );
  }

  // Onboarding non terminé
  if (onboardingComplete === false) {
    return (
      <div className="space-y-4">
        <OnboardingSentinelleVigie
          initialStep={onboardingInitialStep}
          initialData={onboardingInitialData}
          onComplete={handleOnboardingComplete}
          onSkip={handleOnboardingSkip}
        />
      </div>
    );
  }

  // ============================================================================
  // CHAT PLEIN ÉCRAN
  // ============================================================================
  return (
    <div className="flex flex-col bg-white rounded-xl shadow-sm overflow-hidden" style={{ height: 'calc(100vh - 100px)' }}>

      {/* === EN-TÊTE === */}
      <div className="px-5 py-3 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50 flex items-center gap-3 flex-shrink-0">
        <SentinelleAvatar size="md" isThinking={chatLoading} />
        <div className="flex-1 min-w-0">
          <h1 className="font-semibold text-gray-900 text-lg">SENTINELLE</h1>
          <p className="text-xs text-gray-500">
            {chatLoading ? 'SENTINELLE réfléchit...' : 'Votre copilote copropriété'}
          </p>
        </div>
        <button
          onClick={resetChat}
          className="inline-flex items-center gap-1.5 text-sm text-blue-600 font-medium px-3 py-1.5 rounded-lg bg-white border border-blue-200 hover:bg-blue-50 hover:border-blue-300 transition-colors shadow-sm"
          title="Nouvelle conversation"
        >
          <RotateCcw className="w-3.5 h-3.5" />
          Nouveau chat
        </button>
      </div>

      {/* === ALERTE QUOTA (inline, visible si < 5 restantes) === */}
      {alerteQuota && (
        <div className={`px-5 py-2.5 flex items-center gap-2 text-sm flex-shrink-0 ${
          quotaEpuise
            ? 'bg-red-50 border-b border-red-200 text-red-700'
            : 'bg-amber-50 border-b border-amber-200 text-amber-700'
        }`}>
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          {quotaEpuise ? (
            <span>Quota SENTINELLE épuisé — les analyses sont suspendues.</span>
          ) : (
            <span>Plus que <strong>{quotaRestant}</strong> analyse{quotaRestant! > 1 ? 's' : ''} SENTINELLE restante{quotaRestant! > 1 ? 's' : ''}.</span>
          )}
        </div>
      )}

      {/* === ZONE DE MESSAGES (scrollable) === */}
      <div
        ref={chatContainerRef}
        className="flex-1 overflow-y-auto p-5 space-y-4"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {/* Overlay drag'n'drop */}
        {isDragOver && (
          <div className="fixed inset-0 z-50 bg-blue-500/10 backdrop-blur-sm flex items-center justify-center pointer-events-none">
            <div className="bg-white rounded-2xl shadow-2xl p-8 text-center border-2 border-dashed border-blue-400 min-w-[320px]">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Upload className="w-8 h-8 text-blue-500" />
              </div>
              <p className="text-lg font-semibold text-gray-800 mb-1">Déposez votre document</p>
              <p className="text-sm text-gray-500 mb-4">SENTINELLE va l'analyser et le classer automatiquement</p>
              <div className="flex items-center justify-center gap-2 flex-wrap">
                {['PDF', 'JPG / PNG', 'Word', 'Excel'].map(fmt => (
                  <span key={fmt} className="px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">{fmt}</span>
                ))}
                <span className="text-xs text-gray-400">— max 25 Mo</span>
              </div>
            </div>
          </div>
        )}

        {/* Accueil si conversation vide — Écran d'accueil épuré (Session 172) */}
        {chatMessages.length === 0 && !chatLoading && !analyseEnCours && !resultatAnalyse && (
          <div className="flex flex-col items-center justify-center py-8 px-4">

            {/* === ZONE HÉRO === */}
            <div className="relative mb-6">
              {/* Halo décoratif */}
              <div className="absolute inset-0 -m-6 bg-gradient-to-br from-blue-100/60 via-indigo-50/40 to-transparent rounded-full blur-2xl" />
              <SentinelleAvatar size="xl" className="relative z-10" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-1">
              Bonjour {prenom} !
            </h2>
            <p className="text-sm text-gray-500 mb-8 max-w-md text-center">
              Comment puis-je t'aider aujourd'hui ?
            </p>

            {/* === ZONE SUGGESTIONS — Directement sous le hero === */}
            {suggestionsLoading ? (
              <div className="flex items-center gap-2 text-gray-400 text-sm py-4">
                <Loader2 className="w-4 h-4 animate-spin" />
                <span>Analyse de ta situation en cours...</span>
              </div>
            ) : (
              <div className={`w-full max-w-2xl ${suggestionsBailleur.length > 0 ? 'grid grid-cols-1 sm:grid-cols-2 gap-6' : ''}`}>
                {/* Colonne gauche : Ma copropriété */}
                <div>
                  {suggestionsBailleur.length > 0 && (
                    <div className="flex items-center gap-2.5 mb-4 pb-2.5 border-b-2 border-blue-200">
                      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center">
                        <Home className="w-4.5 h-4.5 text-blue-600" />
                      </div>
                      <span className="text-base font-bold text-gray-800">Ma copropriété</span>
                    </div>
                  )}
                  <div className="flex flex-col gap-2">
                    {suggestionsAccueil.map((suggestion, i) => (
                      <button
                        key={`gen-${i}`}
                        onClick={() => envoyerMessageChat(suggestion)}
                        className={`text-sm px-4 py-2.5 rounded-xl border transition-all text-left ${
                          i === 0
                            ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700 font-medium shadow-sm'
                            : 'bg-white text-gray-700 border-gray-200 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700'
                        }`}
                      >
                        {suggestion}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Colonne droite : Mon bien en location (uniquement si bailleur) */}
                {suggestionsBailleur.length > 0 && (
                  <div>
                    <div className="flex items-center gap-2.5 mb-4 pb-2.5 border-b-2 border-emerald-200">
                      <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
                        <CreditCard className="w-4.5 h-4.5 text-emerald-600" />
                      </div>
                      <span className="text-base font-bold text-emerald-700">Mon bien en location</span>
                    </div>
                    <div className="flex flex-col gap-2">
                      {suggestionsBailleur.map((suggestion, i) => (
                        <button
                          key={`bail-${i}`}
                          onClick={() => envoyerMessageChat(suggestion)}
                          className="text-sm px-4 py-2.5 rounded-xl border transition-all text-left bg-emerald-50 text-emerald-700 border-emerald-200 hover:border-emerald-400 hover:bg-emerald-100"
                        >
                          {suggestion}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Indication drop document */}
            <div className="mt-8 flex items-center gap-2 text-gray-400 text-xs">
              <Paperclip className="w-3.5 h-3.5" />
              <span>Tu peux aussi glisser un document ici ou utiliser le trombone ci-dessous</span>
            </div>
          </div>
        )}

        {/* Messages de la conversation */}
        {chatMessages.map((msg) => (
          <div key={msg.id} className={`flex gap-3 ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}>
            {/* Avatar */}
            {msg.role === 'assistant' ? (
              <SentinelleAvatar size="sm" className="flex-shrink-0 mt-1" />
            ) : (
              <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white text-xs font-bold">
                  {userProfile?.prenom?.charAt(0)?.toUpperCase() || 'V'}
                </span>
              </div>
            )}

            {/* Bulle message */}
            <div className={`max-w-[75%] ${msg.role === 'user' ? 'text-right' : ''}`}>
              <div className={`inline-block rounded-2xl px-4 py-2.5 text-sm ${
                msg.role === 'user'
                  ? 'bg-blue-600 text-white rounded-tr-sm'
                  : 'bg-gray-100 text-gray-800 rounded-tl-sm'
              }`}>
                <div className={msg.role === 'user' ? 'whitespace-pre-wrap' : 'prose prose-sm max-w-none'}>
                  {msg.role === 'user' ? msg.content : (() => {
                    // Session 222 : Détecter liste numérotée en fin de message → chips cliquables
                    // Uniquement si pas d'actions JSON et au moins 2 items
                    if (msg.actions && msg.actions.length > 0) return renderMarkdown(msg.content);
                    const lines = msg.content.trimEnd().split('\n');
                    const chips: string[] = [];
                    let i = lines.length - 1;
                    while (i >= 0) {
                      const t = lines[i].trim();
                      if (/^\d+\.\s+/.test(t)) {
                        chips.unshift(t.replace(/^\d+\.\s+/, '').split(' - ')[0].trim());
                        i--;
                      } else if (t === '') { i--; } else { break; }
                    }
                    if (chips.length < 2) return renderMarkdown(msg.content);
                    const contentSansListe = lines.slice(0, i + 1).join('\n').trimEnd();
                    return (
                      <>
                        {renderMarkdown(contentSansListe)}
                        <div className="flex flex-wrap gap-2 mt-3">
                          {chips.map((chip, idx) => (
                            <button
                              key={idx}
                              onClick={() => setChatInput(chip)}
                              className="text-xs px-3 py-1.5 rounded-full border border-blue-300 bg-white text-blue-700 hover:bg-blue-50 hover:border-blue-400 transition-colors cursor-pointer font-medium"
                            >
                              {chip}
                            </button>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>

              {/* Incitation pièces */}
              {msg.incitationPieces && (
                <div className="mt-1.5 text-xs text-amber-600 italic px-1">
                  {msg.incitationPieces}
                </div>
              )}

              {/* Actions proposées par SENTINELLE */}
              {/* Session 293 : generate_courrier → deux boutons Email / Courrier papier au choix de l'utilisateur */}
              {msg.actions && msg.actions.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2">
                  {msg.actions.map((action) => {
                    if (action.type === 'generate_courrier') {
                      // Deux boutons côte à côte — l'utilisateur choisit le canal
                      return (
                        <React.Fragment key={action.id}>
                          {/* Bouton Email */}
                          <button
                            onClick={() => handleAction(
                              { ...action, data: { ...(action.data as any), modeEnvoiSuggere: 'email' } },
                              msg.courrier
                            )}
                            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-colors bg-green-600 text-white hover:bg-green-700"
                          >
                            <Send className="w-3.5 h-3.5" />
                            Envoyer par email
                          </button>
                          {/* Bouton Courrier papier */}
                          <button
                            onClick={() => handleAction(
                              { ...action, data: { ...(action.data as any), modeEnvoiSuggere: 'postal' } },
                              msg.courrier
                            )}
                            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-colors bg-blue-600 text-white hover:bg-blue-700"
                          >
                            <FileText className="w-3.5 h-3.5" />
                            Courrier papier
                          </button>
                        </React.Fragment>
                      );
                    }

                    // Tous les autres types — comportement inchangé
                    return (
                      <button
                        key={action.id}
                        onClick={() => handleAction(action, msg.courrier)}
                        className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
                          action.type === 'send_email'
                            ? 'bg-green-600 text-white hover:bg-green-700'
                            : action.type === 'create_affaire'
                              ? 'bg-amber-500 text-white hover:bg-amber-600'
                              : action.type === 'update_paiement'
                                ? 'bg-emerald-600 text-white hover:bg-emerald-700'
                                : action.type === 'update_profil_tantiemes'
                                  ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                                  : action.type === 'create_evenement'
                                    ? 'bg-purple-600 text-white hover:bg-purple-700'
                                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        {action.type === 'send_email' && <Send className="w-3.5 h-3.5" />}
                        {action.type === 'create_affaire' && <FolderOpen className="w-3.5 h-3.5" />}
                        {action.type === 'update_paiement' && <CreditCard className="w-3.5 h-3.5" />}
                        {action.type === 'update_profil_tantiemes' && <FileText className="w-3.5 h-3.5" />}
                        {action.type === 'create_evenement' && <Calendar className="w-3.5 h-3.5" />}
                        {action.label}
                      </button>
                    );
                  })}
                </div>
              )}

              {/* Session 181 : Bouton export PDF — uniquement pour les résultats structurés */}
              {msg.role === 'assistant' && isResultatStructure(msg.content) && (
                <div className="mt-2">
                  <button
                    onClick={async () => {
                      let nomCopro = 'Ma copropriete';
                      if (coproprieteId) {
                        try {
                          const coproSnap = await getDoc(doc(db, 'coproprietes', coproprieteId));
                          if (coproSnap.exists()) {
                            nomCopro = coproSnap.data().nom || coproSnap.data().onboardingData?.infosCopropriete?.nomCopropriete || nomCopro;
                          }
                        } catch { /* silencieux */ }
                      }
                      telechargerPDFSentinelle({
                        contenu: msg.content,
                        nomCopropriete: nomCopro,
                        nomUtilisateur: `${userProfile?.prenom || ''} ${userProfile?.nom || ''}`.trim() || 'Utilisateur',
                        dateMessage: msg.timestamp instanceof Date ? msg.timestamp : new Date(msg.timestamp),
                      });
                    }}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-gray-100 text-gray-600 hover:bg-amber-50 hover:text-amber-700 border border-gray-200 hover:border-amber-300 transition-colors"
                    title="Exporter cette analyse en PDF"
                  >
                    <Download className="w-3.5 h-3.5" />
                    Exporter en PDF
                  </button>
                </div>
              )}

              {/* Session 136 : Suggestions de réponse cliquables */}
              {msg.suggestionsReponse && msg.suggestionsReponse.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2">
                  {msg.suggestionsReponse.map((suggestion, idx) => (
                    <button
                      key={`sug_${msg.id}_${idx}`}
                      onClick={() => envoyerMessageChat(suggestion)}
                      className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 hover:border-emerald-300 transition-colors"
                    >
                      {suggestion}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}

        {/* Indicateur de chargement chat */}
        {chatLoading && (
          <div className="flex gap-3">
            <SentinelleAvatar size="sm" isThinking className="flex-shrink-0 mt-1" />
            <div className="bg-gray-100 rounded-2xl rounded-tl-sm px-4 py-3">
              <div className="flex gap-1.5">
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
              </div>
            </div>
          </div>
        )}

        {/* Analyse en cours (dans le flux du chat) */}
        {analyseEnCours && (
          <div className="flex gap-3">
            <SentinelleAvatar size="sm" isThinking className="flex-shrink-0 mt-1" />
            <div className="bg-blue-50 border border-blue-200 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[75%]">
              <div className="flex items-center gap-2">
                <div className="relative w-5 h-5">
                  <div className="absolute inset-0 rounded-full border-2 border-blue-200" />
                  <div className="absolute inset-0 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
                </div>
                <span className="text-sm text-blue-700">{etapeAnalyse}</span>
              </div>
            </div>
          </div>
        )}

        {/* Erreur analyse */}
        {erreurAnalyse && !analyseEnCours && (
          <div className="flex gap-3">
            <SentinelleAvatar size="sm" className="flex-shrink-0 mt-1" />
            <div className="bg-red-50 border border-red-200 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[75%]">
              <div className="flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-red-800">Analyse impossible</p>
                  <p className="text-xs text-red-600 mt-0.5">{erreurAnalyse}</p>
                  <button
                    onClick={() => setErreurAnalyse(null)}
                    className="mt-2 text-xs text-red-600 hover:text-red-800 font-medium"
                  >
                    Réessayer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Résultat analyse — Doublon détecté */}
        {resultatAnalyse && !analyseEnCours && doublonDetecte && doublonDetecte.isDuplicate && !resultatAnalyse.fileUrl && (
          <div className="flex gap-3">
            <SentinelleAvatar size="sm" className="flex-shrink-0 mt-1" />
            <div className="bg-amber-50 border border-amber-300 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[75%]">
              <div className="flex items-start gap-2">
                <Copy className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-amber-800">Document déjà archivé</p>
                  <p className="text-xs text-amber-700 mt-1">
                    Ce fichier (<span className="font-medium">{resultatAnalyse.fileName}</span>) est identique à un document existant :
                  </p>
                  <p className="text-sm font-medium text-amber-900 mt-1.5">
                    "{doublonDetecte.existingDocumentTitre}"
                    {doublonDetecte.existingDocumentDate && (
                      <span className="font-normal text-amber-700">
                        {' '}— archivé le {doublonDetecte.existingDocumentDate.toLocaleDateString('fr-FR')}
                      </span>
                    )}
                  </p>
                  <div className="flex gap-2 mt-3">
                    <button
                      onClick={confirmerArchivageMalgreDoublon}
                      disabled={archivageEnCours}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-600 text-white rounded-lg text-xs font-medium hover:bg-amber-700 disabled:opacity-50 transition-colors"
                    >
                      {archivageEnCours ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Archive className="w-3.5 h-3.5" />}
                      Analyser et archiver quand même
                    </button>
                    <button
                      onClick={fermerResultat}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-gray-600 border border-gray-200 rounded-lg text-xs hover:bg-gray-50 transition-colors"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Résultat analyse — Normal (document analysé, prêt à archiver) */}
        {resultatAnalyse && !analyseEnCours && resultatAnalyse.fileUrl && (
          <div className="flex gap-3">
            <SentinelleAvatar size="sm" className="flex-shrink-0 mt-1" />
            <div className="bg-white border border-gray-200 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[85%] shadow-sm">

              {/* Session 161 : Document hors périmètre → pas d'archivage */}
              {resultatAnalyse.suggestion.typeDocument === 'hors_perimetre' ? (
                <>
                  <div className="flex items-start gap-2 mb-3">
                    <AlertTriangle className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                    <div className="flex-1">
                      <p className="text-sm font-medium text-orange-800">Document hors périmètre</p>
                      <p className="text-xs text-gray-500">{resultatAnalyse.fileName}</p>
                    </div>
                    <button onClick={fermerResultat} className="text-gray-400 hover:text-gray-600">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                  <p className="text-sm text-gray-700 mb-3">
                    {resultatAnalyse.suggestion.explication || 'Ce document n\'a pas de rapport avec la gestion de copropriété. SENTINELLE n\'archive que les documents liés à ta copropriété.'}
                  </p>
                  {resultatAnalyse.suggestion.description && resultatAnalyse.suggestion.description !== resultatAnalyse.suggestion.explication && (
                    <p className="text-xs text-gray-500 mb-3">{resultatAnalyse.suggestion.description}</p>
                  )}
                  <button
                    onClick={fermerResultat}
                    className="w-full px-4 py-2.5 bg-amber-500 text-white rounded-lg text-sm font-medium hover:bg-amber-600 transition-colors"
                  >
                    Compris
                  </button>
                </>
              ) : (
                <>
              {/* En-tête */}
              <div className="flex items-start gap-2 mb-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-sm font-medium text-green-800">Document analysé</p>
                  <p className="text-xs text-gray-500">{resultatAnalyse.fileName}</p>
                  {/* Session 248 : Badge qualité de lecture (Bug 3 fix) */}
                  {resultatAnalyse.suggestion.qualiteLecture && (
                    <span className={`inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                      resultatAnalyse.suggestion.qualiteLecture === 'bonne'
                        ? 'bg-green-100 text-green-700'
                        : resultatAnalyse.suggestion.qualiteLecture === 'moyenne'
                        ? 'bg-amber-100 text-amber-700'
                        : 'bg-red-100 text-red-700'
                    }`}>
                      {resultatAnalyse.suggestion.qualiteLecture === 'bonne'
                        ? 'Bonne qualité de lecture'
                        : resultatAnalyse.suggestion.qualiteLecture === 'moyenne'
                        ? 'Qualité moyenne — l\'analyse peut être incomplète'
                        : 'Qualité faible — données à vérifier manuellement'}
                    </span>
                  )}
                </div>
                <button onClick={fermerResultat} className="text-gray-400 hover:text-gray-600">
                  <X className="w-4 h-4" />
                </button>
              </div>

              {/* Détails */}
              <div className="space-y-1.5 text-sm mb-3">
                <div className="flex gap-2">
                  <span className="text-gray-500 w-20 flex-shrink-0">Titre :</span>
                  <span className="font-medium text-gray-900">{resultatAnalyse.suggestion.titre}</span>
                </div>
                <div className="flex gap-2">
                  <span className="text-gray-500 w-20 flex-shrink-0">Type :</span>
                  <span className="text-gray-700">{resultatAnalyse.suggestion.typeDocumentLabel}</span>
                </div>
                {resultatAnalyse.suggestion.categorieLabel && (
                  <div className="flex gap-2">
                    <span className="text-gray-500 w-20 flex-shrink-0">Catégorie :</span>
                    <span className="text-gray-700">{resultatAnalyse.suggestion.categorieLabel}</span>
                  </div>
                )}
                {resultatAnalyse.suggestion.explication && (
                  <div className="flex gap-2">
                    <span className="text-gray-500 w-20 flex-shrink-0">Analyse :</span>
                    <span className="text-gray-700">{resultatAnalyse.suggestion.explication}</span>
                  </div>
                )}
                {resultatAnalyse.suggestion.actionsRecommandees && resultatAnalyse.suggestion.actionsRecommandees.length > 0 && (
                  <div className="flex gap-2">
                    <span className="text-gray-500 w-20 flex-shrink-0">Actions :</span>
                    <div className="space-y-0.5">
                      {resultatAnalyse.suggestion.actionsRecommandees.map((action: string, idx: number) => (
                        <p key={idx} className="text-gray-700 text-sm">• {action}</p>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Session 252 : Dossier détecté — affichage avant archivage */}
              {resultatAnalyse.suggestion.affaireNom && (
                <div className="flex gap-2 mb-3 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg">
                  <FolderOpen className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
                  <p className="text-xs text-blue-700">
                    Ce document sera rattaché au dossier <span className="font-semibold">{resultatAnalyse.suggestion.affaireNom}</span>
                  </p>
                </div>
              )}

              {/* Session 257 : Nouvel interlocuteur détecté — uniquement si absent de la liste connue */}
              {/* Cast as any : nouvelInterlocuteur existe côté Cloud Function mais pas encore dans le type frontend DocumentSuggestion */}
              {(() => {
                const ni = (resultatAnalyse.suggestion as any).nouvelInterlocuteur as {
                  nom: string; fonction?: string; societe?: string; email?: string; type?: string;
                } | null | undefined;
                if (!ni || !ni.nom || resultatAnalyse.suggestion.interlocuteurId) return null;
                return (
                  <div className="flex flex-col gap-2 mb-3 px-3 py-2.5 bg-purple-50 border border-purple-200 rounded-lg">
                    <div className="flex items-start gap-2">
                      <span className="text-purple-600 mt-0.5 flex-shrink-0">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                        </svg>
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-semibold text-purple-800">Nouvel interlocuteur détecté</p>
                        <p className="text-xs text-purple-700 truncate">
                          {ni.nom}
                          {ni.fonction && <span className="text-purple-500"> — {ni.fonction}</span>}
                          {ni.societe && <span className="text-purple-500"> — {ni.societe}</span>}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        handleAction({
                          id: `ni_${Date.now()}`,
                          type: 'create_interlocuteur',
                          label: `Créer ${ni.nom}`,
                          confidence: 'high',
                          data: {
                            nom: ni.nom,
                            fonction: ni.fonction || undefined,
                            societe: ni.societe || undefined,
                            email: ni.email || undefined,
                            type: ni.type || 'autre',
                          }
                        });
                      }}
                      className="self-start inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white text-xs font-medium rounded-md hover:bg-purple-700 transition-colors"
                    >
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      Créer cet interlocuteur
                    </button>
                  </div>
                );
              })()}

              {/* Session 144 : Intelligence Correspondance — affichage alerte qualité */}
              {resultatAnalyse.suggestion.courrierRef_lie && (
                <div className={`rounded-lg p-3 mb-3 border ${
                  resultatAnalyse.suggestion.qualiteReponse === 'complete' 
                    ? 'bg-green-50 border-green-200' 
                    : resultatAnalyse.suggestion.qualiteReponse === 'partielle'
                    ? 'bg-orange-50 border-orange-200'
                    : 'bg-red-50 border-red-200'
                }`}>
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-lg">
                      {resultatAnalyse.suggestion.typeCorrespondance === 'reponse' ? '\u21A9' : resultatAnalyse.suggestion.typeCorrespondance === 'relance' ? '\u21BB' : '\u2709'}
                    </span>
                    <span className="text-sm font-semibold text-gray-800">
                      {resultatAnalyse.suggestion.typeCorrespondance === 'reponse' ? 'Réponse à ' : 
                       resultatAnalyse.suggestion.typeCorrespondance === 'relance' ? 'Relance de ' : 'Lié à '}
                      {resultatAnalyse.suggestion.courrierRef_lie}
                    </span>
                    {resultatAnalyse.suggestion.qualiteReponse && (
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                        resultatAnalyse.suggestion.qualiteReponse === 'complete' 
                          ? 'bg-green-100 text-green-700' 
                          : resultatAnalyse.suggestion.qualiteReponse === 'partielle'
                          ? 'bg-orange-100 text-orange-700'
                          : 'bg-red-100 text-red-700'
                      }`}>
                        {resultatAnalyse.suggestion.qualiteReponse === 'complete' ? 'Complète' 
                          : resultatAnalyse.suggestion.qualiteReponse === 'partielle' ? 'Partielle' 
                          : 'Incomplète'}
                      </span>
                    )}
                  </div>

                  {/* Alerte qualité */}
                  {resultatAnalyse.suggestion.alerteQualite && (
                    <p className="text-sm text-gray-700 mb-2">{resultatAnalyse.suggestion.alerteQualite}</p>
                  )}

                  {/* Points traités */}
                  {resultatAnalyse.suggestion.pointsTraites && resultatAnalyse.suggestion.pointsTraites.length > 0 && (
                    <div className="mb-1">
                      <p className="text-xs font-medium text-green-700 mb-0.5">Points traités :</p>
                      {resultatAnalyse.suggestion.pointsTraites.map((p: string, i: number) => (
                        <p key={i} className="text-xs text-green-700 ml-2">{'\u2713'} {p}</p>
                      ))}
                    </div>
                  )}

                  {/* Points manquants */}
                  {resultatAnalyse.suggestion.pointsManquants && resultatAnalyse.suggestion.pointsManquants.length > 0 && (
                    <div>
                      <p className="text-xs font-medium text-red-700 mb-0.5">Points sans réponse :</p>
                      {resultatAnalyse.suggestion.pointsManquants.map((p: string, i: number) => (
                        <p key={i} className="text-xs text-red-700 ml-2">{'\u2717'} {p}</p>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Boutons — Session 144 : Réorganisation selon résultat IC */}
              <div className="flex flex-col gap-2">
                {/* Archiver seul = action principale dans tous les cas */}
                <div className="flex gap-2">
                  <button
                    onClick={archiverDocument}
                    disabled={archivageEnCours}
                    className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-amber-500 text-white rounded-lg font-medium text-sm hover:bg-amber-600 disabled:opacity-50 transition-colors"
                  >
                    {archivageEnCours ? <Loader2 className="w-4 h-4 animate-spin" /> : <Archive className="w-4 h-4" />}
                    {resultatAnalyse.suggestion.pointsManquants && resultatAnalyse.suggestion.pointsManquants.length > 0
                      ? 'Archiver seulement'
                      : 'Archiver dans mes documents'}
                  </button>
                  <button
                    onClick={fermerResultat}
                    className="px-4 py-2.5 text-gray-600 border border-gray-200 rounded-lg text-sm hover:bg-gray-50 transition-colors"
                  >
                    Ignorer
                  </button>
                </div>

                {/* Si réponse incomplète/partielle avec points manquants → relance = action secondaire */}
                {resultatAnalyse.suggestion.pointsManquants && resultatAnalyse.suggestion.pointsManquants.length > 0 && (
                  <button
                    onClick={async () => {
                      if (!resultatAnalyse || !coproprieteId || !firebaseUser) return;
                      setArchivageEnCours(true);
                      try {
                        // Archivage inline (sans passer par archiverDocument qui reset l'état)
                        const { suggestion, fileName, fileUrl, fileType, fileSize, fileHash } = resultatAnalyse;
                        const userNom = `${userProfile?.prenom || ''} ${userProfile?.nom || ''}`.trim();

                        await uploadDocument({
                          coproprieteId,
                          titre: suggestion.titre,
                          type: suggestion.typeDocument,
                          categorie: suggestion.categorie || 'administratif',
                          description: suggestion.description || undefined,
                          dateDocument: suggestion.dateDocument ? new Date(suggestion.dateDocument) : undefined,
                          interlocuteurId: suggestion.interlocuteurId || undefined,
                          interlocuteurNom: suggestion.interlocuteurNom || undefined,
                          affaireId: suggestion.affaireId || undefined,
                          visibilite: 'proprietaire',
                          userId: firebaseUser.uid,
                          userNom,
                          fileHash,
                          tempFilePath: fileUrl,
                          fichierNom: fileName,
                          fichierTaille: fileSize,
                          fichierType: fileType,
                          source: 'sentinelle_vigie',
                          typeDocumentLabel: suggestion.typeDocumentLabel,
                          donneesCles: suggestion.donneesCles || {},
                          anomalies: suggestion.anomalies || [],
                          analyseSentinelle: {
                            confiance: suggestion.confidence,
                            explication: suggestion.explication,
                            actionsRecommandees: suggestion.actionsRecommandees,
                            anomalies: suggestion.anomalies || [],
                            donneesCles: suggestion.donneesCles || {},
                            dateAnalyse: Timestamp.now()
                          },
                          sensCorrespondance: suggestion.sensCorrespondance || null,
                          courrierId_lie: suggestion.courrierId_lie || undefined,
                          courrierRef_lie: suggestion.courrierRef_lie || undefined,
                          typeCorrespondance: suggestion.typeCorrespondance || undefined,
                          qualiteReponse: suggestion.qualiteReponse || undefined,
                          pointsTraites: suggestion.pointsTraites || undefined,
                          pointsManquants: suggestion.pointsManquants || undefined,
                          alerteQualite: suggestion.alerteQualite || undefined,
                        });

                        // Session 288 : Appel SENTINELLE pour générer le contenu de relance
                        // Zéro hardcoding — SENTINELLE rédige le contenu complet selon la graduation 1A/1B/1C
                        const pointsManquantsTexte = suggestion.pointsManquants
                          ?.map((p: string) => `- ${p}`).join('\n') || '';
                        const messageRelance = [
                          `Je viens d'archiver une réponse de ${suggestion.interlocuteurNom || 'mon interlocuteur'} à mon courrier.`,
                          suggestion.courrierRef_lie ? `Il s'agit d'une réponse à mon courrier ${suggestion.courrierRef_lie}.` : '',
                          `La réponse est incomplète — les points suivants n'ont pas été traités :\n${pointsManquantsTexte}`,
                          suggestion.affaireId ? `Cette affaire est en cours dans mon dossier.` : '',
                          `Rédige-moi la relance adaptée à cette situation.`,
                        ].filter(Boolean).join(' ');

                        const resultRelance: AssistantResult = await askAssistant(
                          messageRelance,
                          [],
                          coproprieteId,
                          suggestion.affaireId || undefined
                        );

                        // Si SENTINELLE a généré un courrier complet → naviguer vers le formulaire
                        if (resultRelance.courrier?.contenu) {
                          const c = resultRelance.courrier;
                          const destinataireType = (() => {
                            const cat = suggestion.categorie || '';
                            if (cat === 'syndic') return 'syndic';
                            if (cat === 'promoteur') return 'promoteur';
                            if (cat === 'constructeur') return 'constructeur';
                            if (cat === 'assurance') return 'assurance';
                            if (cat === 'avocat') return 'avocat';
                            if (cat === 'prestataire') return 'prestataire';
                            return 'autre';
                          })();
                          navigate('/vigie/courriers/nouveau', {
                            state: {
                              fromSentinelle: true,
                              prefill: {
                                objet: c.objet || `Relance - ${suggestion.interlocuteurNom || 'notre échange'}`,
                                contenu: c.contenu,
                                type: c.type || 'relance',
                                destinataire: c.destinataireNom || suggestion.interlocuteurNom || '',
                                destinataireType: c.destinataireType || destinataireType,
                                modeEnvoi: c.modeEnvoiSuggere || 'email',
                                courrierId_lie: suggestion.courrierId_lie || undefined,
                                affaireId: c.affaireId || suggestion.affaireId || undefined,
                              }
                            }
                          });
                        } else if (resultRelance.actions?.length) {
                          // SENTINELLE a retourné une action generate_courrier → traiter via handleAction
                          const actionCourrier = resultRelance.actions.find((a: ProposedAction) => a.type === 'generate_courrier');
                          if (actionCourrier) {
                            await handleAction(actionCourrier, resultRelance.courrier);
                          } else {
                            // Aucune action courrier — afficher le message SENTINELLE dans le chat
                            setErreurAnalyse(`SENTINELLE n'a pas pu générer la relance. Utilise le chat pour lui demander directement.`);
                            setArchivageEnCours(false);
                          }
                        } else {
                          // Réponse inattendue — ne jamais afficher de squelette
                          setErreurAnalyse(`SENTINELLE n'a pas pu générer la relance. Utilise le chat pour lui demander directement.`);
                          setArchivageEnCours(false);
                        }
                      } catch (error) {
                        console.error('Erreur archivage+relance:', error);
                        const errMsg = error instanceof Error ? error.message : '';
                        if (errMsg.startsWith('DOUBLON_DETECTE|')) {
                          const parts = errMsg.split('|');
                          setErreurAnalyse(parts[1] || 'Ce document existe déjà dans ta GED.');
                        } else {
                          setErreurAnalyse('Erreur lors de l\'archivage. Réessayez.');
                        }
                        setArchivageEnCours(false);
                      }
                    }}
                    disabled={archivageEnCours}
                    className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-medium text-sm hover:bg-gray-50 disabled:opacity-50 transition-colors"
                  >
                    {archivageEnCours ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                    Archiver et rédiger une relance ({resultatAnalyse.suggestion.pointsManquants.length} point{resultatAnalyse.suggestion.pointsManquants.length > 1 ? 's' : ''})
                  </button>
                )}

                {/* Session 216 : Affichage niveau de relance calculé côté serveur */}
                {resultatAnalyse.suggestion.niveauRelance && resultatAnalyse.suggestion.pointsManquants && resultatAnalyse.suggestion.pointsManquants.length > 0 && (
                  <p className="text-xs text-center text-gray-500 mt-1">
                    Niveau détecté : <span className="font-medium text-gray-700">{resultatAnalyse.suggestion.niveauRelance}</span>
                  </p>
                )}
              </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Erreur chat */}
        {chatError && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-xs text-red-700 flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <div>
              <p>{chatError}</p>
              <button onClick={() => setChatError(null)} className="text-red-600 font-medium mt-1 hover:underline">
                Fermer
              </button>
            </div>
          </div>
        )}

        {/* Ancre scroll */}
        <div ref={chatEndRef} />
      </div>

      {/* === ZONE DE SAISIE + TROMBONE === */}
      <div className="border-t border-gray-100 p-4 flex-shrink-0 bg-white">
        {/* Indication formats — visible en permanence */}
        <div className="flex items-center gap-1.5 mb-2 flex-wrap">
          <Paperclip className="w-3 h-3 text-gray-300 flex-shrink-0" />
          <span className="text-[11px] text-gray-300">Glisse un document ou utilise le trombone :</span>
          {['PDF', 'JPG/PNG', 'Word', 'Excel'].map(fmt => (
            <span key={fmt} className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-400">{fmt}</span>
          ))}
        </div>
        <div className="flex items-end gap-2">
          {/* Bouton trombone (sélectionner fichier) */}
          <button
            onClick={() => fileInputRef.current?.click()}
            disabled={analyseEnCours}
            className="p-2.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-colors disabled:opacity-50 flex-shrink-0"
            title="Joindre un document"
          >
            <Paperclip className="w-5 h-5" />
          </button>
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileSelect}
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
            className="hidden"
          />

          {/* Bouton dictée vocale */}
          <BoutonDictee
            onTranscript={(text) => {
              setChatInput(prev => prev ? prev + ' ' + text : text);
              // Reset le placeholder après transcription finale
              const textarea = document.querySelector('textarea') as HTMLTextAreaElement;
              if (textarea) textarea.placeholder = 'Décris ta situation ou dépose un document...';
            }}
            onInterim={(text) => {
              // Afficher le texte en cours de reconnaissance dans le placeholder
              const textarea = document.querySelector('textarea') as HTMLTextAreaElement;
              if (textarea) textarea.placeholder = text + '...';
            }}
            disabled={chatLoading}
          />

          {/* Zone de texte */}
          <textarea
            value={chatInput}
            onChange={(e) => setChatInput(e.target.value)}
            onKeyDown={handleChatKeyDown}
            placeholder="Décris ta situation ou dépose un document..."
            rows={1}
            disabled={chatLoading}
            className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm text-gray-900 placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 disabled:opacity-50 transition-colors"
            style={{ maxHeight: '120px', minHeight: '42px' }}
            onInput={(e) => {
              const target = e.target as HTMLTextAreaElement;
              target.style.height = '42px';
              target.style.height = Math.min(target.scrollHeight, 120) + 'px';
            }}
          />

          {/* Bouton envoyer */}
          <button
            onClick={() => envoyerMessageChat(chatInput)}
            disabled={!chatInput.trim() || chatLoading}
            className="p-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-shrink-0"
          >
            {chatLoading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <Send className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

    </div>
  );
};

export default SentinelleVigiePage;
